var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrorRobot404(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Page_cant_be_found_graphic",
    "data-name": "Page cant be found graphic",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 524.131,
    height: 466.269,
    viewBox: "0 0 524.131 466.269",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31588",
    "data-name": "Rectangle 31588",
    width: 524.131,
    height: 466.269,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31534",
    "data-name": "Rectangle 31534",
    width: 524.131,
    height: 731.272,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39106",
    "data-name": "Path 39106",
    d: "M245.412,0C67.068,0,.072,111.972,0,234.106v.357c.025,53.3,12.784,108.51,34.587,157.188C46.555,423.7,136.379,448.6,245.412,448.6s198.857-24.9,210.826-56.945c46.2-79.812,67.864-148.122,67.893-204.3V187.1C524.066,64.64,421.1,0,245.412,0Z",
    transform: "translate(0 0.004)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31535",
    "data-name": "Rectangle 31535",
    width: 7.775,
    height: 8.197,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31536",
    "data-name": "Rectangle 31536",
    width: 7.445,
    height: 6.984,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31537",
    "data-name": "Rectangle 31537",
    width: 7.54,
    height: 7.65,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31538",
    "data-name": "Rectangle 31538",
    width: 7.499,
    height: 7.134,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31539",
    "data-name": "Rectangle 31539",
    width: 6.558,
    height: 6.824,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31540",
    "data-name": "Rectangle 31540",
    width: 6.135,
    height: 8.378,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-10"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31541",
    "data-name": "Rectangle 31541",
    width: 4.628,
    height: 8.151,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-11"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31542",
    "data-name": "Rectangle 31542",
    width: 4.573,
    height: 8.654,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-12"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31543",
    "data-name": "Rectangle 31543",
    width: 10.571,
    height: 5.97,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-13"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31544",
    "data-name": "Rectangle 31544",
    width: 10.135,
    height: 4.372,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-14"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31545",
    "data-name": "Rectangle 31545",
    width: 10.41,
    height: 5.127,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-15"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31546",
    "data-name": "Rectangle 31546",
    width: 10.02,
    height: 4.716,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-16"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31547",
    "data-name": "Rectangle 31547",
    width: 8.945,
    height: 4.826,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-17"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31548",
    "data-name": "Rectangle 31548",
    width: 11.007,
    height: 1.939,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-18"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31549",
    "data-name": "Rectangle 31549",
    width: 10.666,
    height: 2.054,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-19"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31550",
    "data-name": "Rectangle 31550",
    width: 11.043,
    height: 1.484,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-20"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31551",
    "data-name": "Rectangle 31551",
    width: 10.415,
    height: 2.089,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-21"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31552",
    "data-name": "Rectangle 31552",
    width: 9.514,
    height: 1.553,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-22"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31553",
    "data-name": "Rectangle 31553",
    width: 9.911,
    height: 10.026,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-23"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31554",
    "data-name": "Rectangle 31554",
    width: 11.525,
    height: 3.947,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-24"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31555",
    "data-name": "Rectangle 31555",
    width: 46.662,
    height: 44.293,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-25"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31556",
    "data-name": "Rectangle 31556",
    width: 14.954,
    height: 24.147,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-26"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31557",
    "data-name": "Rectangle 31557",
    width: 11.324,
    height: 23.108,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-27"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31558",
    "data-name": "Rectangle 31558",
    width: 63.108,
    height: 7.718,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-28"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31559",
    "data-name": "Rectangle 31559",
    width: 57.802,
    height: 7.069,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-29"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31560",
    "data-name": "Rectangle 31560",
    width: 52.389,
    height: 6.406,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-30"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31561",
    "data-name": "Rectangle 31561",
    width: 109.906,
    height: 49.15,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-31"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31562",
    "data-name": "Rectangle 31562",
    width: 40.63,
    height: 82.423,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-32"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31563",
    "data-name": "Rectangle 31563",
    width: 25.447,
    height: 45.856,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-33"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31564",
    "data-name": "Rectangle 31564",
    width: 84.927,
    height: 16.347,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-34"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31565",
    "data-name": "Rectangle 31565",
    width: 28.15,
    height: 20.623,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-35"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31566",
    "data-name": "Rectangle 31566",
    width: 20.085,
    height: 48.393,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-36"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31567",
    "data-name": "Rectangle 31567",
    width: 29.769,
    height: 76.553,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-37"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31568",
    "data-name": "Rectangle 31568",
    width: 31.564,
    height: 53.844,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-38"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31569",
    "data-name": "Rectangle 31569",
    width: 16.882,
    height: 64.002,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-39"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31571",
    "data-name": "Rectangle 31571",
    width: 8.844,
    height: 7.094,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-40"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31572",
    "data-name": "Rectangle 31572",
    width: 9.353,
    height: 7.902,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-41"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31573",
    "data-name": "Rectangle 31573",
    width: 8.822,
    height: 6.839,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-42"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31574",
    "data-name": "Rectangle 31574",
    width: 1.586,
    height: 10.428,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-43"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31575",
    "data-name": "Rectangle 31575",
    width: 3.269,
    height: 10.193,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-44"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31576",
    "data-name": "Rectangle 31576",
    width: 8.228,
    height: 7.925,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-45"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31577",
    "data-name": "Rectangle 31577",
    width: 10.001,
    height: 6.884,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-46"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31578",
    "data-name": "Rectangle 31578",
    width: 9.335,
    height: 5.888,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-47"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31579",
    "data-name": "Rectangle 31579",
    width: 2.283,
    height: 10.417,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-48"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31580",
    "data-name": "Rectangle 31580",
    width: 4.403,
    height: 10.064,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-49"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31581",
    "data-name": "Rectangle 31581",
    width: 6.512,
    height: 9.324,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-50"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31582",
    "data-name": "Rectangle 31582",
    width: 10.954,
    height: 4.364,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-51"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31583",
    "data-name": "Rectangle 31583",
    width: 10.066,
    height: 3.571,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-52"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31584",
    "data-name": "Rectangle 31584",
    width: 6.622,
    height: 9.301,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-53"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31585",
    "data-name": "Rectangle 31585",
    width: 47.51,
    height: 46.77,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-54"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31586",
    "data-name": "Rectangle 31586",
    width: 18.484,
    height: 21.171,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-55"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31587",
    "data-name": "Rectangle 31587",
    width: 17.853,
    height: 18.93,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_13071",
    "data-name": "Group 13071",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12912",
    "data-name": "Group 12912",
    transform: "translate(0 -0.003)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12911",
    "data-name": "Group 12911",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38888",
    "data-name": "Path 38888",
    d: "M476.628,567.709c0,35.481-95,64.245-212.181,64.245S52.265,603.19,52.265,567.709s95-64.245,212.181-64.245,212.181,28.764,212.181,64.245",
    transform: "translate(-19.034 -183.351)",
    fill: "#559c33"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38889",
    "data-name": "Path 38889",
    d: "M264.446,505.935c115.821,0,209.964,28.1,212.139,63.009.025-.411.043-.823.043-1.235,0-35.481-95-64.244-212.181-64.244S52.265,532.228,52.265,567.709c0,.413.017.825.043,1.235,2.175-34.911,96.318-63.009,212.139-63.009",
    transform: "translate(-19.034 -183.352)",
    fill: "#dedbe8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38890",
    "data-name": "Path 38890",
    d: "M265.223,526.424c-109.033,0-198.857,24.9-210.826,56.945,11.969,32.044,101.793,56.945,210.826,56.945s198.857-24.9,210.826-56.945c-11.969-32.044-101.793-56.945-210.826-56.945",
    transform: "translate(-19.811 -191.713)",
    fill: "#201e21"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_13070",
    "data-name": "Group 13070",
    transform: "translate(0 -0.003)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13069",
    "data-name": "Group 13069",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38891",
    "data-name": "Path 38891",
    d: "M361.873,597.467a8.6,8.6,0,0,0-2.1-4.164l-10.624-11.412-13.86,7.143a8.6,8.6,0,0,0-3.386,3.207s-17.283,36.349-21.1,49.2c-2.783,9.369-6.718,38.534-6.718,38.534s10.655,14.086,25.071,16.6,29.209-7.136,29.209-7.136,6.167-28.776,6.718-38.534c.756-13.381-3.207-53.433-3.207-53.433",
    transform: "translate(-110.743 -211.914)",
    fill: "#2b2b2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38892",
    "data-name": "Path 38892",
    d: "M368.147,598.562a8.6,8.6,0,0,0-2.1-4.164l-10.625-11.412-13.859,7.143a8.6,8.6,0,0,0-3.386,3.207s-17.283,36.349-21.1,49.2c-2.783,9.369-6.718,38.534-6.718,38.534s10.655,14.086,25.071,16.6,29.209-7.136,29.209-7.136,6.167-28.776,6.718-38.534c.756-13.381-3.207-53.433-3.207-53.433",
    transform: "translate(-113.028 -212.313)",
    fill: "#4f5152"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38893",
    "data-name": "Path 38893",
    d: "M377.239,582.588l-3.989-.7-2.985,1.539,2.6,1.411Z",
    transform: "translate(-134.845 -211.914)",
    fill: "#2b2b2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38894",
    "data-name": "Path 38894",
    d: "M393.532,730.685a36.678,36.678,0,1,1-34.264-38.942,36.678,36.678,0,0,1,34.264,38.942",
    transform: "translate(-116.631 -251.893)",
    fill: "#3c3c3c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38895",
    "data-name": "Path 38895",
    d: "M392.8,731.559a34.961,34.961,0,1,1-32.66-37.119,34.96,34.96,0,0,1,32.66,37.119",
    transform: "translate(-117.614 -252.877)",
    fill: "#686868"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38896",
    "data-name": "Path 38896",
    d: "M390.969,733.754a30.648,30.648,0,1,1-28.631-32.54,30.648,30.648,0,0,1,28.631,32.54",
    transform: "translate(-120.085 -255.347)",
    fill: "#121212"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38897",
    "data-name": "Path 38897",
    d: "M385.2,596.306a8.6,8.6,0,0,0-2.541-3.911l-11.8-10.191-13,8.606a8.6,8.6,0,0,0-3.018,3.555s-13.234,38.01-15.633,51.2c-1.75,9.616-2.494,39.036-2.494,39.036s12.121,12.845,26.725,13.779,28.261-10.265,28.261-10.265,3.005-29.275,2.494-39.036c-.7-13.383-8.99-52.769-8.99-52.769",
    transform: "translate(-122.624 -212.028)",
    fill: "#a8a9a9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38898",
    "data-name": "Path 38898",
    d: "M391.553,596.712a8.6,8.6,0,0,0-2.541-3.911l-11.8-10.191-13,8.606a8.6,8.6,0,0,0-3.018,3.555s-13.234,38.01-15.633,51.2c-1.75,9.616-2.494,39.036-2.494,39.036s12.12,12.845,26.725,13.779,28.261-10.265,28.261-10.265,3.006-29.275,2.494-39.036c-.7-13.383-8.989-52.769-8.989-52.769",
    transform: "translate(-124.939 -212.176)",
    fill: "#d6dbdd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38899",
    "data-name": "Path 38899",
    d: "M392.852,582.463l-4.041-.258-2.8,1.853,2.737,1.121Z",
    transform: "translate(-140.58 -212.028)",
    fill: "#a8a9a9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38900",
    "data-name": "Path 38900",
    d: "M582.549,215.375s13.793-9.051,18-24.917-4.3-19.155-5.146-20.324-8.065-10.13-14.658-9.023a23.569,23.569,0,0,0-18.812,1.784s-12.987,7.7-14.705,14.894-.639,8.875-2.052,9.458-2.567,3.173-.563,8,3.644,9.818,3.644,9.818Z",
    transform: "translate(-197.949 -58.246)",
    fill: "#d6dbdd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38901",
    "data-name": "Path 38901",
    d: "M608.154,185.55s10.708-10.037,14.675-13.215,15.005-13,14.852-16.081-4.022-3.84-5.546-3.112-15.462,13.329-16.913,14.985-11.854,11.3-11.754,11.578,4.687,5.845,4.687,5.845",
    transform: "translate(-219.774 -55.676)",
    fill: "#009edd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38902",
    "data-name": "Path 38902",
    d: "M609.335,185.2s10.245-9.711,13.869-12.613,13.965-11.585,13.825-14.4a2.858,2.858,0,0,0-3.986-2.8c-1.392.665-14.938,12.608-16.264,14.12s-11.236,10.7-11.145,10.961,3.7,4.73,3.7,4.73",
    transform: "translate(-220.563 -56.499)",
    fill: "#29bef3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38903",
    "data-name": "Path 38903",
    d: "M614.148,191.187a2.638,2.638,0,0,0,1.032-.463,47.613,47.613,0,0,0,6.677-5.678c.481-.5.748-.846.676-.91-1.682-1.464-5.764-5.251-6.464-6.15-.139-.181-.51-.02-1.024.361a46.51,46.51,0,0,0-5.814,6.017,4.663,4.663,0,0,0-.608.821c-.059.355,5.03,6.008,5.526,6",
    transform: "translate(-221.651 -64.79)",
    fill: "#1d1c1c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38904",
    "data-name": "Path 38904",
    d: "M630.075,176.91a1.979,1.979,0,0,0,.856-.381,44.254,44.254,0,0,0,6.975-6.4c.243-.3.358-.495.307-.542-1.682-1.464-5.845-5.467-6.545-6.366-.118-.153-.438-.07-.889.178a45.012,45.012,0,0,0-6.885,5.862,3.164,3.164,0,0,0-.5.6c-.055.353,6.188,7.065,6.683,7.054",
    transform: "translate(-227.03 -59.412)",
    fill: "#1d1c1c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38905",
    "data-name": "Path 38905",
    d: "M646.009,161.65a2.344,2.344,0,0,0,1.091-.564,43.488,43.488,0,0,0,5.517-5.733c2.15-3.641-1.8-8.95-5.014-7.393a83.675,83.675,0,0,0-7.07,5.493,7.778,7.778,0,0,0-1.207,1.143c-.055.353,6.188,7.064,6.683,7.054",
    transform: "translate(-232.833 -53.781)",
    fill: "#1d1c1c"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_12915",
    "data-name": "Group 12915",
    transform: "translate(406.492 99.672)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12914",
    "data-name": "Group 12914"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12913",
    "data-name": "Group 12913",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38906",
    "data-name": "Path 38906",
    d: "M646.009,164.956a2.344,2.344,0,0,0,1.091-.564,27.383,27.383,0,0,1-6.567-7.633,7.777,7.777,0,0,0-1.207,1.143c-.055.353,6.188,7.064,6.683,7.054",
    transform: "translate(-639.325 -156.759)",
    fill: "#d6dbdd"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12918",
    "data-name": "Group 12918",
    transform: "translate(403.749 103.731)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12917",
    "data-name": "Group 12917"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12916",
    "data-name": "Group 12916",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38907",
    "data-name": "Path 38907",
    d: "M635.012,163.4a15.455,15.455,0,0,0,7.126,6.729c.243-.3.359-.5.307-.542-1.681-1.465-5.844-5.467-6.545-6.366-.118-.153-.437-.07-.888.179",
    transform: "translate(-635.012 -163.143)",
    fill: "#d6dbdd"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12921",
    "data-name": "Group 12921",
    transform: "translate(396.361 109.848)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12920",
    "data-name": "Group 12920"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12919",
    "data-name": "Group 12919",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38908",
    "data-name": "Path 38908",
    d: "M630.075,180.413a1.979,1.979,0,0,0,.856-.382c-1.483-1.679-5.46-5.692-7.037-7.269a3.165,3.165,0,0,0-.5.6c-.055.353,6.188,7.065,6.683,7.054",
    transform: "translate(-623.391 -172.763)",
    fill: "#d6dbdd"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12924",
    "data-name": "Group 12924",
    transform: "translate(393.393 113.121)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12923",
    "data-name": "Group 12923"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12922",
    "data-name": "Group 12922",
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38909",
    "data-name": "Path 38909",
    d: "M618.724,178.345c.9,1.626,4.942,5.223,6.812,6.7.48-.5.747-.846.675-.91-1.682-1.465-5.764-5.252-6.464-6.151-.138-.181-.51-.02-1.023.361",
    transform: "translate(-618.724 -177.911)",
    fill: "#d6dbdd"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12927",
    "data-name": "Group 12927",
    transform: "translate(386.97 119.572)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12926",
    "data-name": "Group 12926"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12925",
    "data-name": "Group 12925",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38910",
    "data-name": "Path 38910",
    d: "M614.148,194.882a2.638,2.638,0,0,0,1.032-.463c-2.487-1.476-4.816-4.654-5.95-6.361a4.663,4.663,0,0,0-.608.821c-.059.355,5.03,6.008,5.526,6",
    transform: "translate(-608.622 -188.058)",
    fill: "#d6dbdd"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_38911",
    "data-name": "Path 38911",
    d: "M598.359,213.139s14.2-1.5,18.764-2.737,17.81-7.4,18.146-10.259-3.1-4.147-4.611-3.715-15.835,6.347-17.815,6.878-15.02,2.613-15.089,2.883.6,6.949.6,6.949",
    transform: "translate(-217.692 -71.504)",
    fill: "#009edd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38912",
    "data-name": "Path 38912",
    d: "M599.9,213.187s13.541-1.542,17.713-2.674S634.1,204.3,634.4,201.691a2.661,2.661,0,0,0-3.227-3.185c-1.381.395-15.588,5.9-17.4,6.384s-14.235,2.473-14.3,2.721.418,5.577.418,5.577",
    transform: "translate(-218.32 -72.26)",
    fill: "#29bef3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38913",
    "data-name": "Path 38913",
    d: "M645.262,204.576a2.193,2.193,0,0,0,1.089-.348,40.562,40.562,0,0,0,5.952-4.41c2.537-3.01-.265-8.5-3.459-7.564A78.123,78.123,0,0,0,641.5,196.2a7.3,7.3,0,0,0-1.284.862c-.1.315,4.589,7.443,5.044,7.511",
    transform: "translate(-233.158 -69.975)",
    fill: "#1d1c1c"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_12930",
    "data-name": "Group 12930",
    transform: "translate(407.058 126.228)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12929",
    "data-name": "Group 12929"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12928",
    "data-name": "Group 12928",
    clipPath: "url(#clip-path-9)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38914",
    "data-name": "Path 38914",
    d: "M645.262,206.9a2.194,2.194,0,0,0,1.089-.348,25.512,25.512,0,0,1-4.849-8.025,7.3,7.3,0,0,0-1.284.862c-.1.315,4.589,7.443,5.044,7.511",
    transform: "translate(-640.216 -198.526)",
    fill: "#d6dbdd"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_38915",
    "data-name": "Path 38915",
    d: "M624.82,213.254a1.831,1.831,0,0,0,.87-.071,41.214,41.214,0,0,0,8.1-3.473c.306-.189.467-.325.437-.381-1.026-1.805-3.451-6.6-3.789-7.611-.057-.17-.363-.2-.836-.117a41.888,41.888,0,0,0-7.856,3.028,3.019,3.019,0,0,0-.625.367c-.157.294,3.26,8.114,3.7,8.257",
    transform: "translate(-226.202 -73.402)",
    fill: "#1d1c1c"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_12933",
    "data-name": "Group 12933",
    transform: "translate(403.401 128.155)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12932",
    "data-name": "Group 12932"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12931",
    "data-name": "Group 12931",
    clipPath: "url(#clip-path-10)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38916",
    "data-name": "Path 38916",
    d: "M634.464,201.6a14.386,14.386,0,0,0,4.188,8.109c.306-.189.467-.325.437-.381-1.026-1.805-3.451-6.6-3.789-7.61-.057-.17-.363-.2-.836-.117",
    transform: "translate(-634.464 -201.557)",
    fill: "#d6dbdd"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12936",
    "data-name": "Group 12936",
    transform: "translate(394.915 131.226)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12935",
    "data-name": "Group 12935"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12934",
    "data-name": "Group 12934",
    clipPath: "url(#clip-path-11)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38917",
    "data-name": "Path 38917",
    d: "M624.82,215.013a1.831,1.831,0,0,0,.87-.071c-.786-1.932-3.044-6.683-3.943-8.554a3.019,3.019,0,0,0-.625.368c-.157.294,3.26,8.114,3.7,8.257",
    transform: "translate(-621.117 -206.387)",
    fill: "#d6dbdd"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_38918",
    "data-name": "Path 38918",
    d: "M594.846,170.713s6.582-14.624,9.249-19.5,9.673-19.417,8.222-22.462-5.671-2.182-6.9-.808-9.993,19.942-10.762,22.222-7.209,16.375-6.99,16.618,7.183,3.926,7.183,3.926",
    transform: "translate(-214.017 -46.138)",
    fill: "#009edd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38919",
    "data-name": "Path 38919",
    d: "M595.528,170.327s6.252-14.1,8.688-18.552,9.217-17.554,7.893-20.336-4.071-2.4-5.2-1.146-9.769,18.994-10.47,21.077-6.836,15.518-6.635,15.74,5.721,3.217,5.721,3.217",
    transform: "translate(-214.798 -47.101)",
    fill: "#29bef3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38920",
    "data-name": "Path 38920",
    d: "M598.557,179.585a2.884,2.884,0,0,0,.846-.9,51.979,51.979,0,0,0,4.348-8.533c.273-.709.4-1.167.3-1.2-2.312-.771-8.021-2.875-9.1-3.487-.216-.124-.523.195-.881.794a50.923,50.923,0,0,0-3.336,8.513,5.112,5.112,0,0,0-.268,1.083c.09.383,7.6,3.947,8.1,3.733",
    transform: "translate(-215.037 -60.247)",
    fill: "#1d1c1c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38921",
    "data-name": "Path 38921",
    d: "M608.486,158.293a2.166,2.166,0,0,0,.7-.745,48.384,48.384,0,0,0,4.345-9.387c.119-.4.154-.65.083-.676-2.312-.771-8.193-3.058-9.277-3.671-.184-.1-.471.114-.821.553-1.38,1.721-3.706,6.808-4.482,8.806a3.5,3.5,0,0,0-.257.812c.093.379,9.211,4.525,9.706,4.307",
    transform: "translate(-218.067 -52.364)",
    fill: "#1d1c1c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38922",
    "data-name": "Path 38922",
    d: "M618.194,135.741a2.568,2.568,0,0,0,.864-1.027,47.523,47.523,0,0,0,3.155-8.1c.638-4.575-5.573-8.272-8.164-5.35a91.884,91.884,0,0,0-4.823,8.512,8.557,8.557,0,0,0-.737,1.659c.093.379,9.211,4.524,9.706,4.307",
    transform: "translate(-221.602 -43.781)",
    fill: "#1d1c1c"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_12939",
    "data-name": "Group 12939",
    transform: "translate(386.885 85.996)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12938",
    "data-name": "Group 12938"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12937",
    "data-name": "Group 12937",
    clipPath: "url(#clip-path-12)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38923",
    "data-name": "Path 38923",
    d: "M618.194,141.212a2.568,2.568,0,0,0,.864-1.027,29.914,29.914,0,0,1-9.833-4.939,8.556,8.556,0,0,0-.737,1.659c.093.379,9.211,4.524,9.706,4.307",
    transform: "translate(-608.487 -135.249)",
    fill: "#d6dbdd"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12942",
    "data-name": "Group 12942",
    transform: "translate(385.453 91.426)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12941",
    "data-name": "Group 12941"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12940",
    "data-name": "Group 12940",
    clipPath: "url(#clip-path-13)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38924",
    "data-name": "Path 38924",
    d: "M606.235,144.369a16.885,16.885,0,0,0,10.016,3.793c.119-.4.153-.65.082-.675-2.311-.771-8.193-3.058-9.277-3.671-.184-.1-.471.113-.821.553",
    transform: "translate(-606.235 -143.79)",
    fill: "#d6dbdd"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12945",
    "data-name": "Group 12945",
    transform: "translate(380.713 100.811)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12944",
    "data-name": "Group 12944"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12943",
    "data-name": "Group 12943",
    clipPath: "url(#clip-path-14)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38925",
    "data-name": "Path 38925",
    d: "M608.486,163.669a2.166,2.166,0,0,0,.7-.745c-2.2-1.071-7.9-3.447-10.153-4.374a3.5,3.5,0,0,0-.257.812c.093.379,9.211,4.525,9.706,4.307",
    transform: "translate(-598.78 -158.55)",
    fill: "#d6dbdd"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12948",
    "data-name": "Group 12948",
    transform: "translate(379.028 105.189)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12947",
    "data-name": "Group 12947"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12946",
    "data-name": "Group 12946",
    clipPath: "url(#clip-path-15)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38926",
    "data-name": "Path 38926",
    d: "M596.13,166.256c1.588,1.264,7.18,3.191,9.687,3.9.273-.709.4-1.168.3-1.2-2.312-.771-8.021-2.875-9.1-3.487-.216-.124-.523.194-.881.793",
    transform: "translate(-596.13 -165.436)",
    fill: "#d6dbdd"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12951",
    "data-name": "Group 12951",
    transform: "translate(375.421 114.522)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12950",
    "data-name": "Group 12950"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12949",
    "data-name": "Group 12949",
    clipPath: "url(#clip-path-16)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38927",
    "data-name": "Path 38927",
    d: "M598.557,184.931a2.883,2.883,0,0,0,.846-.9c-3.128-.443-6.813-2.67-8.675-3.915a5.112,5.112,0,0,0-.268,1.083c.09.383,7.6,3.947,8.1,3.733",
    transform: "translate(-590.458 -180.115)",
    fill: "#d6dbdd"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_38928",
    "data-name": "Path 38928",
    d: "M584.591,167.053s-.486-16.03-.223-21.577.193-21.692-2.444-23.795-6.054.521-6.559,2.3-.252,22.3.056,24.691.689,17.878.993,18,8.177.384,8.177.384",
    transform: "translate(-209.435 -44.028)",
    fill: "#4b7b2e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38929",
    "data-name": "Path 38929",
    d: "M584.577,166.954s-.554-15.415-.313-20.483.6-19.818-1.81-21.738-4.712-.376-5.174,1.246-.464,21.353-.183,23.533.65,16.943.928,17.056,6.552.387,6.552.387",
    transform: "translate(-210.101 -45.099)",
    fill: "#559c33"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38930",
    "data-name": "Path 38930",
    d: "M584.559,177.376a2.875,2.875,0,0,0,.366-1.181,52.04,52.04,0,0,0,.172-9.575c-.065-.757-.153-1.225-.258-1.212-2.415.32-8.47.928-9.713.853-.248-.017-.385.4-.444,1.1a50.861,50.861,0,0,0,.729,9.114,5.089,5.089,0,0,0,.234,1.091c.248.305,8.559.221,8.913-.189",
    transform: "translate(-209.277 -60.237)",
    fill: "#1d1c1c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38931",
    "data-name": "Path 38931",
    d: "M584.515,153.666a2.162,2.162,0,0,0,.306-.978,48.388,48.388,0,0,0-.2-10.342c-.07-.416-.146-.652-.222-.643-2.415.32-8.7.839-9.947.763-.21-.013-.374.308-.5.857-.488,2.15-.35,7.742-.174,9.879a3.52,3.52,0,0,0,.125.842c.25.3,10.263.035,10.612-.378",
    transform: "translate(-208.903 -51.604)",
    fill: "#1d1c1c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38932",
    "data-name": "Path 38932",
    d: "M583.746,128.68a2.575,2.575,0,0,0,.327-1.3,47.545,47.545,0,0,0-.711-8.665c-1.43-4.393-8.633-5-9.683-1.234a91.586,91.586,0,0,0-.609,9.764,8.492,8.492,0,0,0,.064,1.814c.25.3,10.262.035,10.612-.378",
    transform: "translate(-208.703 -41.879)",
    fill: "#1d1c1c"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_12954",
    "data-name": "Group 12954",
    transform: "translate(364.363 85.367)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12953",
    "data-name": "Group 12953"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12952",
    "data-name": "Group 12952",
    clipPath: "url(#clip-path-17)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38933",
    "data-name": "Path 38933",
    d: "M583.746,135.693a2.575,2.575,0,0,0,.327-1.3,29.928,29.928,0,0,1-11-.135,8.493,8.493,0,0,0,.064,1.814c.25.3,10.262.035,10.612-.378",
    transform: "translate(-573.066 -134.259)",
    fill: "#d6dbdd"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12957",
    "data-name": "Group 12957",
    transform: "translate(365.049 90.097)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12956",
    "data-name": "Group 12956"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12955",
    "data-name": "Group 12955",
    clipPath: "url(#clip-path-18)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38934",
    "data-name": "Path 38934",
    d: "M574.144,143.323a16.885,16.885,0,0,0,10.665-.977c-.07-.416-.146-.651-.221-.643-2.416.319-8.7.838-9.948.762-.21-.013-.374.308-.5.857",
    transform: "translate(-574.144 -141.701)",
    fill: "#d6dbdd"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12960",
    "data-name": "Group 12960",
    transform: "translate(364.876 101.086)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12959",
    "data-name": "Group 12959"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12958",
    "data-name": "Group 12958",
    clipPath: "url(#clip-path-19)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38935",
    "data-name": "Path 38935",
    d: "M584.608,159.959a2.16,2.16,0,0,0,.306-.978c-2.448,0-8.612.362-11.043.514a3.525,3.525,0,0,0,.125.842c.25.3,10.263.035,10.612-.378",
    transform: "translate(-573.872 -158.982)",
    fill: "#d6dbdd"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12963",
    "data-name": "Group 12963",
    transform: "translate(365.405 105.171)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12962",
    "data-name": "Group 12962"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12961",
    "data-name": "Group 12961",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38936",
    "data-name": "Path 38936",
    d: "M574.705,167.359c1.981.441,7.852-.276,10.415-.74-.065-.757-.153-1.224-.258-1.211-2.416.319-8.47.928-9.713.852-.248-.017-.385.4-.444,1.1",
    transform: "translate(-574.705 -165.408)",
    fill: "#d6dbdd"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12966",
    "data-name": "Group 12966",
    transform: "translate(366.134 115.958)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12965",
    "data-name": "Group 12965"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12964",
    "data-name": "Group 12964",
    clipPath: "url(#clip-path-21)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38937",
    "data-name": "Path 38937",
    d: "M585,183.555a2.875,2.875,0,0,0,.366-1.181c-3.006.972-7.295.584-9.514.279a5.083,5.083,0,0,0,.234,1.091c.248.305,8.559.221,8.913-.189",
    transform: "translate(-575.851 -182.374)",
    fill: "#d6dbdd"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_38938",
    "data-name": "Path 38938",
    d: "M547.183,168.427s-7.822-6.825-9.785-9.249-4.849-14.99-6.377-16.146-6.806-.61-6.652,4.161,3.5,15.919,4.7,17.658,13.679,13.133,15.04,12.232,4.76-7.172,3.079-8.657",
    transform: "translate(-190.967 -51.9)",
    fill: "#009edd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38939",
    "data-name": "Path 38939",
    d: "M544.463,176.408c1.16-1.3,2.923-5.177,2.549-6.157-.7-.614-7.944-6.96-9.9-9.378-1.073-1.324-2.129-4.448-3.617-9.064-.842-2.61-1.99-6.169-2.553-6.872a3.337,3.337,0,0,0-2.23-.039,2.8,2.8,0,0,0-2.124,3.057c.153,4.741,3.526,15.568,4.447,16.9,1.211,1.755,10.828,10.308,13.431,11.549",
    transform: "translate(-191.774 -52.707)",
    fill: "#29bef3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38940",
    "data-name": "Path 38940",
    d: "M581.148,212.344s15.1-10.953,17.678-20.9-3.454-15.421-4.564-15.511-4.269-6.579-10.876-8.636-19.439.219-20.364,1.325a12.11,12.11,0,0,1-5.545,4.382c-3.362,1.322-4.661.163-5.294.349s-5.116,7.257-4.673,10.252,5.4,19.415,6.223,20.3,25.008,9.207,27.416,8.436",
    transform: "translate(-199.384 -60.624)",
    fill: "#1d1c1c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38941",
    "data-name": "Path 38941",
    d: "M582.429,214.37s11.388-8.259,13.33-15.757-2.6-11.628-3.442-11.7-3.219-4.961-8.2-6.511-14.659.165-15.356,1a9.132,9.132,0,0,1-4.182,3.3c-2.534,1-3.515.123-3.992.263s-3.858,5.472-3.524,7.73,4.072,14.64,4.692,15.306,18.858,6.942,20.673,6.361",
    transform: "translate(-202.866 -65.471)",
    fill: "#353535"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38942",
    "data-name": "Path 38942",
    d: "M531.655,174.771c.076.11.161.231.262.359,1.865,2.443,7.492,7.555,8.89,7.628.4.024.851-2.934,2.412-5.3,1.674-2.534,4.057-2.589,4.341-3.951.364-1.757-3.5-6-6.206-7.693a3.361,3.361,0,0,0-1.949-.7c-2.035.305-9.282,7.4-7.751,9.655",
    transform: "translate(-193.545 -60.126)",
    fill: "#1d1c1c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38943",
    "data-name": "Path 38943",
    d: "M524.332,155.509c1.216.989,10.828-2.011,11.094-2.486a2.2,2.2,0,0,0,.045-1.262c0-.024-.01-.051-.013-.079a46.277,46.277,0,0,0-2.861-8.374c-2.577-4.031-10.32-3.187-10.508.717a86.411,86.411,0,0,0,1.737,9.713c.067.279.127.531.182.754a4.167,4.167,0,0,0,.324,1.017",
    transform: "translate(-190.137 -51.224)",
    fill: "#1d1c1c"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_12969",
    "data-name": "Group 12969",
    transform: "translate(337.9 104.978)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12968",
    "data-name": "Group 12968"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12967",
    "data-name": "Group 12967",
    clipPath: "url(#clip-path-22)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38944",
    "data-name": "Path 38944",
    d: "M531.655,174.771c.076.11.161.231.262.359,2.194-2.315,5.426-6.508,9.438-9.314a3.361,3.361,0,0,0-1.949-.7c-2.035.305-9.282,7.4-7.751,9.655",
    transform: "translate(-531.444 -165.104)",
    fill: "#d6dbdd"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12972",
    "data-name": "Group 12972",
    transform: "translate(333.872 100.536)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12971",
    "data-name": "Group 12971"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12970",
    "data-name": "Group 12970",
    clipPath: "url(#clip-path-23)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38945",
    "data-name": "Path 38945",
    d: "M525.433,161.866c1.216.989,10.828-2.011,11.094-2.486a2.2,2.2,0,0,0,.045-1.262c-2.58.9-7.906,2.606-11.463,2.731a4.17,4.17,0,0,0,.324,1.017",
    transform: "translate(-525.109 -158.118)",
    fill: "#d6dbdd"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_38946",
    "data-name": "Path 38946",
    d: "M512.4,400.037l33.25,5.844a1.97,1.97,0,0,0,1.129-3.746l-30.717-11.259Z",
    transform: "translate(-186.607 -142.349)",
    fill: "#d6dbdd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38947",
    "data-name": "Path 38947",
    d: "M513.8,397.8l33.268,5.911a2.007,2.007,0,0,0,1.343-.228,1.969,1.969,0,0,0-1.126-1.348l-30.717-11.259Z",
    transform: "translate(-187.12 -142.349)",
    fill: "#434343"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38948",
    "data-name": "Path 38948",
    d: "M550.256,375.551c10.355,4.6,16.3,15.969,13.276,25.393s-13.867,13.335-24.223,8.735-16.3-15.969-13.277-25.393,13.868-13.335,24.223-8.735",
    transform: "translate(-191.287 -136.066)",
    fill: "#686868"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38949",
    "data-name": "Path 38949",
    d: "M551.71,379.5c8.992,4.023,14.34,13.385,11.944,20.909s-11.626,10.362-20.618,6.339S528.7,393.364,531.092,385.84s11.626-10.362,20.618-6.338",
    transform: "translate(-193.208 -137.541)",
    fill: "#d6dbdd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38950",
    "data-name": "Path 38950",
    d: "M554.155,382.753c7.633,3.221,11.929,11.173,9.6,17.759s-10.413,9.315-18.046,6.094-11.928-11.172-9.6-17.759,10.413-9.315,18.046-6.094",
    transform: "translate(-195.012 -138.898)",
    fill: "#121212"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38951",
    "data-name": "Path 38951",
    d: "M530.963,323.407l.724-9.028.22-2.742.133-1.676.72-8.986,25.607,2.05,20.118,1.609-.722,8.991,0,0-.137,1.674-.219,2.753-.722,9.013-42.721-3.421Z",
    transform: "translate(-193.369 -109.608)",
    fill: "#559c33"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38952",
    "data-name": "Path 38952",
    d: "M531.972,375.242a24.889,24.889,0,0,1-4.093-14.181l.334-25.619.163-12.306a1.481,1.481,0,0,1,2.187-1.184,1.716,1.716,0,0,1,.219.145,39.539,39.539,0,0,0,7.209,4.524,41.32,41.32,0,0,0,14.884,4.062,40.836,40.836,0,0,0,23.174-4.951,1.126,1.126,0,0,1,.238-.1,1.479,1.479,0,0,1,1.975,1.508l-3.2,21.635L572.72,364.65a25.443,25.443,0,0,1-2.108,7.087c-4.072,8.742-12.83,14.275-22.1,13.535a22.053,22.053,0,0,1-16.536-10.029",
    transform: "translate(-192.245 -117.182)",
    fill: "#d6dbdd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38953",
    "data-name": "Path 38953",
    d: "M578.17,315.3l.853-10.666L533.3,300.977l-.853,10.659c.074.067.146.126.214.181a41.367,41.367,0,0,0,45.264,3.637,2.742,2.742,0,0,0,.245-.152",
    transform: "translate(-193.91 -109.609)",
    fill: "#4b7b2e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38954",
    "data-name": "Path 38954",
    d: "M531.831,283.4c-.072-.055-.141-.114-.217-.182a5.148,5.148,0,0,1-1.813-3.489l5.319-45.173s2.071-5.858,14.8-6.873c1.094-.089,2.269-.142,3.529-.148,1.186-.009,2.452.02,3.8.1.589.032,1.2.072,1.816.123a53.8,53.8,0,0,1,11.853,2.121c10.1,3.185,10.642,8.4,10.642,8.4l-1.333,32.353-.541,13.108c-.079,1.015-1.33,2.473-2.338,3.153l0,0a2.3,2.3,0,0,1-.245.156,40.778,40.778,0,0,1-23.171,4.946,41.36,41.36,0,0,1-11.773-2.7,40.25,40.25,0,0,1-10.316-5.884",
    transform: "translate(-192.944 -82.86)",
    fill: "#d6dbdd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_12975",
    "data-name": "Group 12975",
    transform: "translate(341.948 144.67)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12974",
    "data-name": "Group 12974"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12973",
    "data-name": "Group 12973",
    clipPath: "url(#clip-path-24)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38955",
    "data-name": "Path 38955",
    d: "M584.474,238.265s-.9-8.788-22.494-10.516c-20.946-1.675-23.94,6.8-23.94,6.8a121.253,121.253,0,0,0,3.617,37.273s.025-16.547,6.429-28.488,36.388-5.071,36.388-5.071",
    transform: "translate(-537.812 -227.531)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_38956",
    "data-name": "Path 38956",
    d: "M536.969,382.278a14.1,14.1,0,1,1,13,14.853,13.961,13.961,0,0,1-13-14.853",
    transform: "translate(-195.542 -134.575)",
    fill: "#3c3c3c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38957",
    "data-name": "Path 38957",
    d: "M473.778,359.147c1.553,1.6,2.752,4.422,2.213,9.782-.9,8.8-6.93,12.7-11.167,14.365a21.937,21.937,0,0,1-2.41-2.4c-.252-.289-.483-.582-.7-.87a18.109,18.109,0,0,1-3.487-7.1c1.584-7.147,3.627-10.586,7.316-12.257a14.779,14.779,0,0,1,3.615-1.052,36.8,36.8,0,0,1,4.624-.468",
    transform: "translate(-166.879 -130.794)",
    fill: "#d6dbdd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_12978",
    "data-name": "Group 12978",
    transform: "translate(294.288 228.353)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12977",
    "data-name": "Group 12977"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12976",
    "data-name": "Group 12976",
    clipPath: "url(#clip-path-25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38958",
    "data-name": "Path 38958",
    d: "M475.464,359.147c1.553,1.6,2.752,4.422,2.213,9.782-.9,8.8-6.93,12.7-11.167,14.365a21.936,21.936,0,0,1-2.41-2.4c-.252-.289-.483-.582-.7-.87a19.273,19.273,0,0,1,.366-10.368,18.617,18.617,0,0,1,7.078-10.039,36.8,36.8,0,0,1,4.624-.468",
    transform: "translate(-462.853 -359.147)",
    fill: "#121212"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_38959",
    "data-name": "Path 38959",
    d: "M437.014,375.573l41.679,6.931,1.2-5.72-43.289-6.7Z",
    transform: "translate(-159.005 -134.776)",
    fill: "#1d1c1c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38960",
    "data-name": "Path 38960",
    d: "M436.118,363.531l43.591,5.54.886-5.777-44.884-5.2Z",
    transform: "translate(-158.68 -130.41)",
    fill: "#4e4e4e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38961",
    "data-name": "Path 38961",
    d: "M480,357.839c12.456-.264,23.5,7.85,23.5,7.85l-6.347,24.168s-12.225,2.781-23.707-2.412a25.168,25.168,0,0,1-8-5.6l-.009-.009a.917.917,0,0,1,.21-1.427c3.276-1.918,8.512-5.909,9.395-12.148.989-6.989-2.237-8.343-5.541-8.635a.325.325,0,0,1-.079-.631c.293-.095.6-.181.91-.256h.01a45.525,45.525,0,0,1,9.657-.9",
    transform: "translate(-169.416 -130.315)",
    fill: "#d6dbdd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_12981",
    "data-name": "Group 12981",
    transform: "translate(295.774 228.426)",
    opacity: 0.36
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12980",
    "data-name": "Group 12980"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12979",
    "data-name": "Group 12979",
    clipPath: "url(#clip-path-26)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38962",
    "data-name": "Path 38962",
    d: "M470.337,359.263h.01c2.4.179,7.192,1.52,5.97,9.622-1.31,8.629-8.249,12.369-10.866,13.486l-.009-.009a.918.918,0,0,1,.21-1.427c3.276-1.918,8.512-5.909,9.4-12.148.988-6.989-2.238-8.342-5.541-8.634a.325.325,0,0,1-.079-.632c.294-.095.6-.18.91-.256",
    transform: "translate(-465.19 -359.262)",
    fill: "#1d1c1c"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_38963",
    "data-name": "Path 38963",
    d: "M516.483,381.157l34.782,4.4a2.046,2.046,0,0,0,.983-3.942L522.188,370.19Z",
    transform: "translate(-188.096 -134.815)",
    fill: "#d6dbdd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38964",
    "data-name": "Path 38964",
    d: "M567.288,384.354a2.449,2.449,0,1,1-2.126,2.734,2.449,2.449,0,0,1,2.126-2.734",
    transform: "translate(-205.817 -139.967)",
    fill: "#1d1c1c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38965",
    "data-name": "Path 38965",
    d: "M567.29,383.662a2.271,2.271,0,1,1-1.972,2.536,2.271,2.271,0,0,1,1.972-2.536",
    transform: "translate(-205.874 -139.715)",
    fill: "#4b7b2e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38966",
    "data-name": "Path 38966",
    d: "M567.513,383.664a1.827,1.827,0,1,1-1.586,2.04,1.827,1.827,0,0,1,1.586-2.04",
    transform: "translate(-206.097 -139.717)",
    fill: "#559c33"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38967",
    "data-name": "Path 38967",
    d: "M389.019,363.987a8.586,8.586,0,1,1-12.143-.04,8.587,8.587,0,0,1,12.143.04",
    transform: "translate(-136.33 -131.633)",
    fill: "#121212"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38968",
    "data-name": "Path 38968",
    d: "M383.459,374.324a3.227,3.227,0,1,0,1.325-4.367,3.227,3.227,0,0,0-1.325,4.367",
    transform: "translate(-139.512 -134.592)",
    fill: "#1d1c1c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38969",
    "data-name": "Path 38969",
    d: "M382.663,374.955a2.993,2.993,0,1,0,1.228-4.05,2.992,2.992,0,0,0-1.228,4.05",
    transform: "translate(-139.232 -134.947)",
    fill: "#009edd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38970",
    "data-name": "Path 38970",
    d: "M382.7,375.449a2.407,2.407,0,1,0,.988-3.258,2.407,2.407,0,0,0-.988,3.258",
    transform: "translate(-139.271 -135.44)",
    fill: "#29bef3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38971",
    "data-name": "Path 38971",
    d: "M369.491,496.591c-7.717,6.32-10.359,15.855-5.9,21.3s14.326,4.73,22.042-1.59,10.359-15.855,5.9-21.3-14.326-4.73-22.042,1.59",
    transform: "translate(-131.625 -178.938)",
    fill: "#121212"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38972",
    "data-name": "Path 38972",
    d: "M409.139,300.857s-6.818,3.245-26.4,1.076c-19.526-2.162-25.45-6.814-25.45-6.814l2.172-19.621,51.849,5.738Z",
    transform: "translate(-130.12 -100.33)",
    fill: "#272626"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38973",
    "data-name": "Path 38973",
    d: "M383.977,460.208l-5.94,33.532-.428,2.412-3.506,19.79-.427,2.412-.114.652s-5.946,2.634-22.74.316c-16.75-2.316-21.74-6.456-21.74-6.456l2.55-50.664Z",
    transform: "translate(-119.847 -167.599)",
    fill: "#121212"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38974",
    "data-name": "Path 38974",
    d: "M411.543,281.6s-6.746,6.708-26.835,4.26c-19.854-2.42-24.949-10.571-24.949-10.571l2.136-17.524,51.783,6.311Z",
    transform: "translate(-131.02 -93.87)",
    fill: "#272626"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38975",
    "data-name": "Path 38975",
    d: "M410.24,279.029a76.753,76.753,0,0,1-49.045-5.978c-2.5-1.2-3.505-4-2.319-6.036a4.637,4.637,0,0,1,6.033-1.673,68.195,68.195,0,0,0,43.577,5.311,4.637,4.637,0,0,1,5.454,3.073c.661,2.266-.982,4.735-3.7,5.3",
    transform: "translate(-130.517 -96.454)",
    fill: "#1d1c1c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38976",
    "data-name": "Path 38976",
    d: "M387.815,278.525a72.867,72.867,0,0,1-22.858-6.7c-.587-.282-.715-.718-.7-.816a.854.854,0,0,1,.8-.266,1.211,1.211,0,0,1,.375.109,71.939,71.939,0,0,0,45.961,5.6,1.188,1.188,0,0,1,.386-.016.836.836,0,0,1,.713.475,1.13,1.13,0,0,1-.877.6,72.875,72.875,0,0,1-23.8,1.014",
    transform: "translate(-132.657 -98.595)",
    fill: "#d6dbdd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38977",
    "data-name": "Path 38977",
    d: "M388.141,275.856a72.868,72.868,0,0,1-22.858-6.7c-.587-.282-.715-.718-.7-.816a.854.854,0,0,1,.8-.266,1.2,1.2,0,0,1,.375.11,71.944,71.944,0,0,0,45.961,5.6,1.187,1.187,0,0,1,.386-.016.835.835,0,0,1,.713.475,1.13,1.13,0,0,1-.877.6,72.877,72.877,0,0,1-23.8,1.013",
    transform: "translate(-132.775 -97.623)",
    fill: "#559c33"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38978",
    "data-name": "Path 38978",
    d: "M409.1,295.486a92.325,92.325,0,0,1-53.913-6.571c-2.763-1.235-3.895-4.043-2.617-6.073s4.2-2.674,6.6-1.6a82.025,82.025,0,0,0,47.9,5.838c2.588-.464,5.272.861,6.024,3.142s-1.022,4.73-4,5.266",
    transform: "translate(-128.212 -102.234)",
    fill: "#1d1c1c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38979",
    "data-name": "Path 38979",
    d: "M384.6,294.689a88.092,88.092,0,0,1-25.386-7.04l-.017-.008a.539.539,0,0,1,.282-1.021l.044,0a2.174,2.174,0,0,1,.625.172,85.772,85.772,0,0,0,50.09,6.1,2.16,2.16,0,0,1,.644-.017l.044.006a.539.539,0,0,1,.028,1.059l-.018,0a88.086,88.086,0,0,1-26.335.736",
    transform: "translate(-130.702 -104.379)",
    fill: "#d6dbdd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38980",
    "data-name": "Path 38980",
    d: "M385.133,290.282a88.091,88.091,0,0,1-25.386-7.04l-.017-.008a.539.539,0,0,1,.282-1.021l.044,0a2.174,2.174,0,0,1,.625.172,85.772,85.772,0,0,0,50.09,6.1,2.159,2.159,0,0,1,.644-.017l.044.006a.539.539,0,0,1,.028,1.059l-.018,0a88.087,88.087,0,0,1-26.335.736",
    transform: "translate(-130.898 -102.774)",
    fill: "#559c33"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38981",
    "data-name": "Path 38981",
    d: "M381.558,479.335a93.6,93.6,0,0,0-52.821-1.064,2.235,2.235,0,0,1-2.779-1.752q-1.03-5.551-2.061-11.1a2.232,2.232,0,0,1,1.586-2.562,104.025,104.025,0,0,1,59.948,1.207,2.233,2.233,0,0,1,1.48,2.625L384.406,477.7a2.235,2.235,0,0,1-2.848,1.639",
    transform: "translate(-117.945 -167.168)",
    fill: "#272626"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_12984",
    "data-name": "Group 12984",
    transform: "translate(205.914 291.858)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12983",
    "data-name": "Group 12983"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12982",
    "data-name": "Group 12982",
    clipPath: "url(#clip-path-27)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38982",
    "data-name": "Path 38982",
    d: "M323.907,465.474a2.214,2.214,0,0,1,1.555-1.63,104.028,104.028,0,0,1,59.947,1.208,2.214,2.214,0,0,1,1.488,1.691c0-.018.008-.037.013-.055a2.232,2.232,0,0,0-1.481-2.625,104.03,104.03,0,0,0-59.948-1.208,2.233,2.233,0,0,0-1.585,2.563l.01.056",
    transform: "translate(-323.859 -459.026)",
    fill: "#d6dbdd"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_38983",
    "data-name": "Path 38983",
    d: "M413.066,573.283l-2.427-.334-19.912-2.736-2.427-.333c1.6-4.334,7.012-7.182,13.109-6.58,6.521.643,11.508,5.008,11.657,9.983",
    transform: "translate(-141.413 -205.114)",
    fill: "#009edd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38984",
    "data-name": "Path 38984",
    d: "M412.029,574.022l-19.912-2.736c1.413-3.357,5.694-5.529,10.5-5.055,5.151.509,9.114,3.882,9.414,7.791",
    transform: "translate(-142.804 -206.188)",
    fill: "#3cc1f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38985",
    "data-name": "Path 38985",
    d: "M377.11,506.181a85.726,85.726,0,0,0-48.38-.974,2.048,2.048,0,0,1-2.546-1.605L324.3,493.435a2.045,2.045,0,0,1,1.452-2.348,95.287,95.287,0,0,1,54.907,1.106,2.045,2.045,0,0,1,1.356,2.4l-2.295,10.083a2.047,2.047,0,0,1-2.608,1.5",
    transform: "translate(-118.092 -177.567)",
    fill: "#272626"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_12987",
    "data-name": "Group 12987",
    transform: "translate(206.171 310.013)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12986",
    "data-name": "Group 12986"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12985",
    "data-name": "Group 12985",
    clipPath: "url(#clip-path-28)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38986",
    "data-name": "Path 38986",
    d: "M324.308,493.486a2.026,2.026,0,0,1,1.424-1.493,95.276,95.276,0,0,1,54.907,1.106A2.028,2.028,0,0,1,382,494.648l.011-.051a2.045,2.045,0,0,0-1.356-2.4,95.287,95.287,0,0,0-54.907-1.106,2.045,2.045,0,0,0-1.452,2.347l.009.051",
    transform: "translate(-324.263 -487.58)",
    fill: "#d6dbdd"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_38987",
    "data-name": "Path 38987",
    d: "M372.724,532.482a77.7,77.7,0,0,0-43.849-.884,1.855,1.855,0,0,1-2.307-1.455q-.856-4.607-1.71-9.215a1.853,1.853,0,0,1,1.316-2.127,86.357,86.357,0,0,1,49.765,1,1.853,1.853,0,0,1,1.229,2.179q-1.04,4.569-2.08,9.139a1.855,1.855,0,0,1-2.364,1.361",
    transform: "translate(-118.297 -187.78)",
    fill: "#272626"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_12990",
    "data-name": "Group 12990",
    transform: "translate(206.528 327.842)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12989",
    "data-name": "Group 12989"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12988",
    "data-name": "Group 12988",
    clipPath: "url(#clip-path-29)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38988",
    "data-name": "Path 38988",
    d: "M324.865,520.975a1.837,1.837,0,0,1,1.291-1.353,86.357,86.357,0,0,1,49.765,1,1.837,1.837,0,0,1,1.235,1.4c0-.015.007-.031.011-.046a1.853,1.853,0,0,0-1.23-2.179,86.351,86.351,0,0,0-49.765-1,1.853,1.853,0,0,0-1.315,2.127c0,.015.006.031.008.046",
    transform: "translate(-324.825 -515.622)",
    fill: "#d6dbdd"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_38989",
    "data-name": "Path 38989",
    d: "M412.231,351.923a87.993,87.993,0,0,1-1.682,10.213c-.54,2.44-1.15,4.889-1.788,7.339-7.471,28.525-26.351,29.2-26.351,29.2s-6.639,4.408-9.448,9.525c-6.988,1.727-65.574,3.028-65.574,3.028a43.553,43.553,0,0,1-6.745-6.633,66.6,66.6,0,0,1-12.831-24.122q-.33-1.115-.635-2.272a.13.13,0,0,0-.008-.037,83.807,83.807,0,0,1-1.909-30.552c1.112-10.044,8.038-31.44,12.4-42.949a13.825,13.825,0,0,1,14.449-8.837l72.806,8.058a25.426,25.426,0,0,1,7.845,2.187,23.508,23.508,0,0,1,9.436,7.714c1,1.413,2.71,4.263,3.567,5.713,6.043,10.244,7.6,21.085,6.463,32.428",
    transform: "translate(-103.674 -107.701)",
    fill: "#d6dbdd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_12993",
    "data-name": "Group 12993",
    transform: "translate(196.969 254.374)",
    opacity: 0.07
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12992",
    "data-name": "Group 12992"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12991",
    "data-name": "Group 12991",
    clipPath: "url(#clip-path-30)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38990",
    "data-name": "Path 38990",
    d: "M419.7,400.133c-.54,2.44-1.15,4.889-1.788,7.338-7.471,28.525-26.351,29.2-26.351,29.2s-6.639,4.407-9.448,9.525c-6.988,1.727-65.575,3.028-65.575,3.028a43.569,43.569,0,0,1-6.745-6.633h0c34.57,6.7,29.182-23.526,29.182-23.526s37.245-.57,46.268-10.42,34.452-8.51,34.452-8.51",
    transform: "translate(-309.791 -400.072)",
    fill: "#121212"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12996",
    "data-name": "Group 12996",
    transform: "translate(181 188.037)",
    opacity: 0.07
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12995",
    "data-name": "Group 12995"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12994",
    "data-name": "Group 12994",
    clipPath: "url(#clip-path-31)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38991",
    "data-name": "Path 38991",
    d: "M291.968,331.706c-6.6,28.924-5.706,41.746-4.8,46.454a83.806,83.806,0,0,1-1.908-30.551c1.111-10.043,8.038-31.44,12.4-42.949a13.823,13.823,0,0,1,14.449-8.837l13.191,1.46c-5.332-.35-25.625.619-33.337,34.424",
    transform: "translate(-284.674 -295.738)",
    fill: "#121212"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_38992",
    "data-name": "Path 38992",
    d: "M399.53,364.105a36.721,36.721,0,1,1-32.46-40.538,36.722,36.722,0,0,1,32.46,40.538",
    transform: "translate(-118.836 -117.754)",
    fill: "#121212"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38993",
    "data-name": "Path 38993",
    d: "M392.991,371.292a21.195,21.195,0,1,1-18.735-23.4,21.195,21.195,0,0,1,18.735,23.4",
    transform: "translate(-127.73 -126.648)",
    fill: "#282828"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_12999",
    "data-name": "Group 12999",
    transform: "translate(283.457 198.366)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12998",
    "data-name": "Group 12998"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12997",
    "data-name": "Group 12997",
    clipPath: "url(#clip-path-32)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38994",
    "data-name": "Path 38994",
    d: "M470.917,357.84c-1.876-12.02-6-27.182-11.37-34.225a33.167,33.167,0,0,0-13.73-10.759,7.265,7.265,0,0,0,5.635-.872,23.507,23.507,0,0,1,9.435,7.714c1,1.413,2.711,4.262,3.567,5.713,6.043,10.244,7.6,21.085,6.463,32.428",
    transform: "translate(-445.817 -311.984)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_38995",
    "data-name": "Path 38995",
    d: "M391.848,372.548a18.48,18.48,0,1,1-16.335-20.4,18.479,18.479,0,0,1,16.335,20.4",
    transform: "translate(-129.286 -128.203)",
    fill: "#d6dbdd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38996",
    "data-name": "Path 38996",
    d: "M414.966,90.46c1.233,16.946-20.2,32.318-47.877,34.332s-51.11-10.09-52.343-27.036,20.2-32.318,47.877-34.333,51.11,10.091,52.343,27.037",
    transform: "translate(-114.608 -23.015)",
    fill: "#559c33"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_13002",
    "data-name": "Group 13002",
    transform: "translate(207.867 40.186)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13001",
    "data-name": "Group 13001"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13000",
    "data-name": "Group 13000",
    clipPath: "url(#clip-path-33)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38997",
    "data-name": "Path 38997",
    d: "M411.858,75.847c-9.28-8.687-26.059-13.786-44.78-12.424-17.014,1.239-31.668,7.527-40.148,16.125a147.494,147.494,0,0,1,40.354-8.5c17.29-1.259,27.873.737,41.681,4.486a9.863,9.863,0,0,0,2.893.308",
    transform: "translate(-326.931 -63.202)",
    fill: "#559c33"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_38998",
    "data-name": "Path 38998",
    d: "M411.653,70.552a.494.494,0,0,1-.266.838,12.492,12.492,0,0,1-5.956.1c-13.807-3.749-24.391-5.745-41.681-4.486a144.047,144.047,0,0,0-45.43,10.513.616.616,0,0,1-.776-.916c9.811-11.977,26.228-20.458,45.315-21.848A69.7,69.7,0,0,1,395.25,59.92a55.1,55.1,0,0,1,16.4,10.632",
    transform: "translate(-115.594 -19.867)",
    fill: "#d6dbdd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38999",
    "data-name": "Path 38999",
    d: "M418.589,106.273c.031.425.053.851.073,1.273.916,24.381-22.9,45.726-53.9,47.983-31.542,2.3-58.578-16.036-60.391-40.941a38.736,38.736,0,0,1,7.948-25.975c13.12-5.921,29.2-10,46.752-11.276,16.949-1.234,27.321.722,40.859,4.4a13.167,13.167,0,0,0,6.722-.318q1.039,1.023,2,2.1l0,0v0a38.754,38.754,0,0,1,9.46,18.964c.048.261.095.518.13.78.023.141.046.285.064.427.131.849.223,1.71.285,2.576",
    transform: "translate(-110.812 -28.028)",
    fill: "#d6dbdd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39000",
    "data-name": "Path 39000",
    d: "M436.68,107.453c-14.1.5-79.821-1.7-81.951-1.769,1.857-.046,51.947-1.246,64.755-4.628,12.84-3.389,7.712-13.449,7.541-13.774a38.749,38.749,0,0,1,9.46,18.964c.048.261.095.518.13.78.022.141.045.285.064.427",
    transform: "translate(-129.187 -31.784)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39001",
    "data-name": "Path 39001",
    d: "M482.238,170.172c.524,7.2.792,14.755.793,22.489.007.394.005.789,0,1.184l0,1.872-22.189,2.9q-.218.029-.438.045a6.939,6.939,0,0,1-7.6-6.176L449.768,150.8a6.938,6.938,0,0,1,6.628-7.211q.219-.016.44-.02l21.068-.324.427,1.633c.12.46.236.923.352,1.387a140.66,140.66,0,0,1,3.555,23.908",
    transform: "translate(-163.793 -52.165)",
    fill: "#0a0b0b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39002",
    "data-name": "Path 39002",
    d: "M463.465,260.885s9.268-10.563,14.052-11.951,10.67,7.783,11.463,7.762-1.965-15.053-7.3-17.73-19.312,2.393-20.582,5.655,2.371,16.264,2.371,16.264",
    transform: "translate(-167.826 -86.751)",
    fill: "#121212"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39003",
    "data-name": "Path 39003",
    d: "M487.127,255.543s-4.833-9.7-9.86-9.853-10.293,11.195-13.1,13.893-6.239-1.468-4.891-6.5,14.358-15.491,20.214-12.852,7.634,15.315,7.634,15.315",
    transform: "translate(-167.153 -87.332)",
    fill: "#559c33"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_13005",
    "data-name": "Group 13005",
    transform: "translate(291.747 151.417)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13004",
    "data-name": "Group 13004"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13003",
    "data-name": "Group 13003",
    clipPath: "url(#clip-path-34)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39004",
    "data-name": "Path 39004",
    d: "M487.006,253.877s-4.833-9.7-9.86-9.853-10.293,11.195-13.1,13.893-6.239-1.468-4.891-6.5,14.358-15.491,20.214-12.852,7.634,15.315,7.634,15.315",
    transform: "translate(-458.856 -238.142)",
    fill: "#121212"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_39005",
    "data-name": "Path 39005",
    d: "M425.724,209.792c-11.958-27.33-20.462,5.82-24.783,7.356-9.21,3.271-16.712,3.154-40.884,1.686a146.376,146.376,0,0,1-17.141-2.009s0,0-.008,0c-26.831-4.84-36.258-15.511-36.258-15.511s-12.635-17.671-14.3-40.527c-.632-8.685.832-26.043,2.824-35.127a21.2,21.2,0,0,1,.8-2.765l0,0c1.374-3.723,3.881-6.685,8.181-7l9.807.076,95.027.728,1.393.012c5.329-.388,8.879,3.538,10.309,8.363.292.993.6,1.984.914,2.995.425,1.365.865,2.762,1.31,4.244a1.574,1.574,0,0,1-1.567,1.962l-15.666.24c-.139,0-.28.008-.418.018a6.6,6.6,0,0,0-6.306,6.862l2.885,39.636a6.6,6.6,0,0,0,7.233,5.877c.138-.01.279-.025.416-.043l17.06-2.231a1.626,1.626,0,0,1,1.846,1.53c.446,6.069,2.432,35.318-2.676,23.633",
    transform: "translate(-106.416 -42.202)",
    fill: "#d6dbdd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39006",
    "data-name": "Path 39006",
    d: "M413.143,173.781A27.61,27.61,0,1,1,383.6,148.248a27.61,27.61,0,0,1,29.542,25.533",
    transform: "translate(-130.377 -53.96)",
    fill: "#bfc1c1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39007",
    "data-name": "Path 39007",
    d: "M412.527,174.716a26.16,26.16,0,1,1-27.99-24.192,26.16,26.16,0,0,1,27.99,24.192",
    transform: "translate(-131.207 -54.791)",
    fill: "#7c7c7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39008",
    "data-name": "Path 39008",
    d: "M412.2,175.217a25.385,25.385,0,1,1-27.161-23.476A25.386,25.386,0,0,1,412.2,175.217",
    transform: "translate(-131.651 -55.235)",
    fill: "#d6dbdd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39009",
    "data-name": "Path 39009",
    d: "M410.614,177.625A21.654,21.654,0,1,1,387.446,157.6a21.654,21.654,0,0,1,23.168,20.024",
    transform: "translate(-133.789 -57.372)",
    fill: "#4b7b2e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39010",
    "data-name": "Path 39010",
    d: "M410.349,178.028a21.029,21.029,0,1,1-22.5-19.447,21.029,21.029,0,0,1,22.5,19.447",
    transform: "translate(-134.146 -57.73)",
    fill: "#559c33"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39011",
    "data-name": "Path 39011",
    d: "M409.733,178.964a19.578,19.578,0,1,1-20.948-18.105,19.578,19.578,0,0,1,20.948,18.105",
    transform: "translate(-134.977 -58.561)",
    fill: "#bfc1c1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39012",
    "data-name": "Path 39012",
    d: "M409.229,179.73a18.391,18.391,0,1,1-19.677-17.007,18.391,18.391,0,0,1,19.677,17.007",
    transform: "translate(-135.658 -59.241)",
    fill: "#d6dbdd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39013",
    "data-name": "Path 39013",
    d: "M400.42,182.671c.588,8.07,1.743,14.563-6.328,15.15a14.651,14.651,0,1,1-2.127-29.225c8.07-.587,7.867,6,8.454,14.074",
    transform: "translate(-137.8 -61.385)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39014",
    "data-name": "Path 39014",
    d: "M487.238,171.9c.524,7.2.792,14.755.793,22.489l-8.411,1.1-8.025,1.048a4.522,4.522,0,0,1-5.217-3.98l-2.885-39.637a4.523,4.523,0,0,1,4.586-4.694l2.95-.043,12.655-.193a140.663,140.663,0,0,1,3.555,23.908",
    transform: "translate(-168.793 -53.895)",
    fill: "#1d1c1c"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_13008",
    "data-name": "Group 13008",
    transform: "translate(294.688 94.294)",
    opacity: 0.11
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13007",
    "data-name": "Group 13007"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13006",
    "data-name": "Group 13006",
    clipPath: "url(#clip-path-35)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39015",
    "data-name": "Path 39015",
    d: "M479.62,195.6l-8.025,1.048a4.522,4.522,0,0,1-5.217-3.98l-2.885-39.637a4.522,4.522,0,0,1,4.586-4.693l2.95-.044,11.762.552s3.129,34.063-3.17,46.753",
    transform: "translate(-463.481 -148.299)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_39016",
    "data-name": "Path 39016",
    d: "M471.877,195.3c-.076.01-.153.017-.23.022-2.068.151-3.853-1.13-3.979-2.857l-2.885-39.637c-.126-1.726,1.455-3.252,3.523-3.4.077-.005.154-.009.232-.011l15.406-.333c-.086-.364-.173-.727-.263-1.089l-15.6.236a4.523,4.523,0,0,0-4.587,4.694l2.885,39.637a4.523,4.523,0,0,0,5.217,3.98l16.436-2.148c0-.367,0-.731-.005-1.1Z",
    transform: "translate(-168.793 -53.895)",
    fill: "#121212"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39017",
    "data-name": "Path 39017",
    d: "M342.907,216.821c-26.832-4.84-36.259-15.511-36.259-15.511s-12.635-17.671-14.3-40.527c-.632-8.686.832-26.043,2.825-35.127a21.19,21.19,0,0,1,.8-2.765l0,0c1.374-3.723,3.882-6.686,8.182-7l9.807.076s-18.857,3.66-17.583,32.566,10.612,57.668,46.528,68.292",
    transform: "translate(-106.415 -42.202)",
    fill: "#cfd0d0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39018",
    "data-name": "Path 39018",
    d: "M395.44,586.2c-1.544,11.188-26.257,36.21-26.257,36.21s-1.141-.187-3.032-.477c-5.611-.876-17.992-2.478-27.829-4.8-8.547-2.014-23.447-9.311-33.123-14.333l0-.005c-5.489-2.847-9.292-4.964-9.292-4.964l1.052-43.206a18.544,18.544,0,0,1,15.776-15.824l.054-.007a18.506,18.506,0,0,1,5.071.005l64.15,8.854s16.952,13.056,13.434,38.543",
    transform: "translate(-107.764 -196.158)",
    fill: "#d6dbdd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_13011",
    "data-name": "Group 13011",
    transform: "translate(258.387 349.702)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13010",
    "data-name": "Group 13010"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13009",
    "data-name": "Group 13009",
    clipPath: "url(#clip-path-36)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39019",
    "data-name": "Path 39019",
    d: "M435.677,590.344c-1.544,11.188-26.257,36.21-26.257,36.21s-1.141-.187-3.032-.477c0,0,20.6-27.611,20.7-37.763C427.229,573.92,411.883,553.7,409.2,550l13.039,1.8s16.952,13.056,13.434,38.543",
    transform: "translate(-406.388 -550.002)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_39020",
    "data-name": "Path 39020",
    d: "M357.876,605.47a26.914,26.914,0,1,1,12.7-35.88,26.915,26.915,0,0,1-12.7,35.88",
    transform: "translate(-116.309 -201.851)",
    fill: "#121212"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39021",
    "data-name": "Path 39021",
    d: "M357.876,605.47a26.914,26.914,0,1,1,12.7-35.88,26.915,26.915,0,0,1-12.7,35.88",
    transform: "translate(-116.309 -201.851)",
    fill: "#121212"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39022",
    "data-name": "Path 39022",
    d: "M360.619,611.216a26.793,26.793,0,0,1-8.081,2.4,25.431,25.431,0,0,1-3.2.231,26.921,26.921,0,1,1,2.438-53.7,27.176,27.176,0,0,1,9.111,2.613A26.8,26.8,0,0,1,372.54,573.82c.273.494.535,1,.782,1.517a26.919,26.919,0,0,1-10.159,34.5,27.457,27.457,0,0,1-2.544,1.383",
    transform: "translate(-117.308 -203.943)",
    fill: "#272626"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_13014",
    "data-name": "Group 13014",
    transform: "translate(223.668 356.061)",
    opacity: 0.18
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13013",
    "data-name": "Group 13013"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13012",
    "data-name": "Group 13012",
    clipPath: "url(#clip-path-37)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39023",
    "data-name": "Path 39023",
    d: "M360.14,613.846a26.723,26.723,0,0,1-8.357-1.245l2.788-52.078a26.84,26.84,0,0,1,8.007-.378Z",
    transform: "translate(-351.782 -560.004)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39024",
    "data-name": "Path 39024",
    d: "M378.048,612.794a26.788,26.788,0,0,1-8.081,2.4l8.344-50.856A26.8,26.8,0,0,1,389.968,575.4l-9.377,36.014a27.435,27.435,0,0,1-2.544,1.383",
    transform: "translate(-358.405 -561.582)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_39025",
    "data-name": "Path 39025",
    d: "M361.462,609.265a20.986,20.986,0,1,1,9.905-27.976,20.985,20.985,0,0,1-9.905,27.976",
    transform: "translate(-120.704 -207.341)",
    fill: "#3a3939"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_13017",
    "data-name": "Group 13017",
    transform: "translate(188.139 342.641)",
    opacity: 0.07
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13016",
    "data-name": "Group 13016"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13015",
    "data-name": "Group 13015",
    clipPath: "url(#clip-path-38)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39026",
    "data-name": "Path 39026",
    d: "M305.2,602.9c-5.489-2.847-9.292-4.964-9.292-4.964l1.052-43.207a18.544,18.544,0,0,1,15.776-15.824l.054-.007s-11.062,5.865-12.475,18.48c-1.4,12.515,4.793,45.012,4.886,45.522",
    transform: "translate(-295.903 -538.898)",
    fill: "#121212"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_39027",
    "data-name": "Path 39027",
    d: "M331.711,585.055a8.6,8.6,0,0,0-1.258-4.491l-8.222-13.247-14.978,4.333a8.607,8.607,0,0,0-3.942,2.493s-23.973,32.329-30.2,44.2c-4.539,8.656-14.029,36.513-14.029,36.513s7.736,15.878,21.4,21.126,30.036-1.365,30.036-1.365,11.6-27.044,14.029-36.513c3.324-12.983,7.166-53.047,7.166-53.047",
    transform: "translate(-94.354 -206.606)",
    fill: "#2b2b2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39028",
    "data-name": "Path 39028",
    d: "M337.657,587.339a8.6,8.6,0,0,0-1.258-4.491L328.175,569.6,313.2,573.934a8.607,8.607,0,0,0-3.942,2.493s-23.973,32.329-30.2,44.2c-4.539,8.656-14.029,36.513-14.029,36.513s7.736,15.878,21.4,21.126,30.037-1.364,30.037-1.364,11.6-27.044,14.029-36.513c3.325-12.983,7.166-53.047,7.166-53.047",
    transform: "translate(-96.52 -207.438)",
    fill: "#4f5152"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39029",
    "data-name": "Path 39029",
    d: "M360.333,568.768l-3.78-1.452-3.225.933,2.279,1.886Z",
    transform: "translate(-128.677 -206.606)",
    fill: "#2b2b2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39030",
    "data-name": "Path 39030",
    d: "M322.627,720.183a36.678,36.678,0,1,1-21.082-47.392,36.678,36.678,0,0,1,21.082,47.392",
    transform: "translate(-91.667 -244.126)",
    fill: "#3c3c3c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39031",
    "data-name": "Path 39031",
    d: "M322.008,720.551a34.961,34.961,0,1,1-20.1-45.174,34.961,34.961,0,0,1,20.1,45.174",
    transform: "translate(-92.65 -245.11)",
    fill: "#686868"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39032",
    "data-name": "Path 39032",
    d: "M320.453,721.475a30.648,30.648,0,1,1-17.617-39.6,30.648,30.648,0,0,1,17.617,39.6",
    transform: "translate(-95.121 -247.581)",
    fill: "#121212"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39033",
    "data-name": "Path 39033",
    d: "M344.5,589.969a8.6,8.6,0,0,0-1.258-4.491L335.02,572.23l-14.978,4.333a8.606,8.606,0,0,0-3.942,2.493s-23.973,32.329-30.2,44.2c-4.539,8.656-14.029,36.513-14.029,36.513s7.736,15.878,21.4,21.126,30.036-1.364,30.036-1.364,11.6-27.044,14.029-36.513c3.325-12.983,7.166-53.047,7.166-53.047",
    transform: "translate(-99.012 -208.395)",
    fill: "#a8a9a9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39034",
    "data-name": "Path 39034",
    d: "M350.446,592.253a8.6,8.6,0,0,0-1.258-4.491l-8.223-13.248-14.977,4.334a8.607,8.607,0,0,0-3.942,2.493s-23.973,32.329-30.2,44.2c-4.539,8.656-14.029,36.513-14.029,36.513s7.736,15.878,21.4,21.126,30.037-1.365,30.037-1.365,11.6-27.044,14.029-36.513c3.324-12.983,7.166-53.047,7.166-53.047",
    transform: "translate(-101.177 -209.227)",
    fill: "#d6dbdd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39035",
    "data-name": "Path 39035",
    d: "M373.122,573.682l-3.78-1.452-3.225.933,2.279,1.886Z",
    transform: "translate(-133.335 -208.396)",
    fill: "#a8a9a9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39036",
    "data-name": "Path 39036",
    d: "M306.054,425.473l-21.878,25.711a1.97,1.97,0,0,0,2.658,2.871L312.1,433.269Z",
    transform: "translate(-103.322 -154.949)",
    fill: "#d6dbdd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39037",
    "data-name": "Path 39037",
    d: "M308.33,428.468l-21.944,25.693a2.005,2.005,0,0,0-.484,1.274,1.968,1.968,0,0,0,1.733-.289L312.9,434.361Z",
    transform: "translate(-104.122 -156.04)",
    fill: "#434343"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39038",
    "data-name": "Path 39038",
    d: "M298.522,467.051c-9.21,6.6-22.024,5.967-28.62-1.412s-4.475-18.711,4.736-25.31,22.024-5.967,28.62,1.412,4.475,18.711-4.736,25.31",
    transform: "translate(-96.897 -158.697)",
    fill: "#686868"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39039",
    "data-name": "Path 39039",
    d: "M298.7,467.77c-8.023,5.716-18.8,5.586-24.078-.29s-3.047-15.272,4.976-20.988,18.8-5.586,24.078.29,3.047,15.272-4.976,20.988",
    transform: "translate(-98.97 -161.073)",
    fill: "#d6dbdd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39040",
    "data-name": "Path 39040",
    d: "M298.061,468.622c-6.643,4.95-15.675,4.628-20.172-.72s-2.758-13.7,3.885-18.647,15.675-4.628,20.173.72,2.758,13.7-3.885,18.647",
    transform: "translate(-100.293 -162.331)",
    fill: "#121212"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31570",
    "data-name": "Rectangle 31570",
    width: 22.953,
    height: 46.79,
    transform: "translate(168.043 358.107) rotate(-89.006)",
    fill: "#559c33"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39041",
    "data-name": "Path 39041",
    d: "M312.4,505.3a1.512,1.512,0,0,1-2.386,1.206,42.2,42.2,0,0,0-46.316-.788,1.511,1.511,0,0,1-2.338-1.29l.625-36.018a25.523,25.523,0,0,1,51.039.886Z",
    transform: "translate(-95.184 -161.453)",
    fill: "#d6dbdd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39042",
    "data-name": "Path 39042",
    d: "M311.269,543.036l-.189,10.913-46.783-.811.189-10.906c.083-.06.161-.114.236-.163a42.2,42.2,0,0,1,46.315.788,2.809,2.809,0,0,1,.233.179",
    transform: "translate(-96.253 -195.032)",
    fill: "#4b7b2e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39043",
    "data-name": "Path 39043",
    d: "M312.145,549.164l-2.6,46.339s-1.788,8.833-23.878,8.45c-21.431-.372-23.632-9.274-23.632-9.274l-.929-46.388c.022-1.3,1.4-2.867,2.421-3.527a42.2,42.2,0,0,1,46.315.788c1,.7,2.321,2.489,2.3,3.613",
    transform: "translate(-95.092 -196.012)",
    fill: "#d6dbdd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39044",
    "data-name": "Path 39044",
    d: "M357.22,678.775s-5.012,12.611-12.508,14.3c-6,1.352-11.6,2.6-12.275,2.728a8.35,8.35,0,0,1-2.5-.469c-4.084-1.148-10.091-9.881-9.879-10.735.275-1.109,3.248-5.095,5.944-3.423,2.131,1.321,2.4,4.942,4.62,5.587a4.958,4.958,0,0,0,1.24.262c.432-.025,5.376-1.063,10.891-2.242,7.369-1.575,7.813-11.08,7.813-11.08Z",
    transform: "translate(-116.56 -245.351)",
    fill: "#009edd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39045",
    "data-name": "Path 39045",
    d: "M355.962,680.354c-2.341,3.084-5.7,11.333-10.616,12.439-5.962,1.342-11.239,2.522-12.133,2.7a12.15,12.15,0,0,1-2.143-.483c-3.256-.944-7.45-7.3-8.344-9.043a5.7,5.7,0,0,1,2.392-2.231,1.06,1.06,0,0,1,1.02.071c1.45.9,2.582,3.849,3.548,4.561a6.839,6.839,0,0,0,1.691,1.249,4.763,4.763,0,0,0,1.556.275c.5-.029,5.369-1.046,10.981-2.245,5.073-1.083,5.661-7.519,7.922-10.441Z",
    transform: "translate(-117.532 -246.626)",
    fill: "#29bef3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39046",
    "data-name": "Path 39046",
    d: "M327.323,684.831a2.378,2.378,0,0,0-.446-1.159,44,44,0,0,0-5.149-6.176c-3.42-2.562-9.19.815-7.983,4.22a84.828,84.828,0,0,0,4.737,7.711,7.894,7.894,0,0,0,1.014,1.338c.348.094,7.782-5.436,7.827-5.934",
    transform: "translate(-114.202 -246.404)",
    fill: "#1d1c1c"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_13020",
    "data-name": "Group 13020",
    transform: "translate(204.28 437.268)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13019",
    "data-name": "Group 13019"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13018",
    "data-name": "Group 13018",
    clipPath: "url(#clip-path-39)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39047",
    "data-name": "Path 39047",
    d: "M330.13,688.884a2.378,2.378,0,0,0-.446-1.159,27.68,27.68,0,0,1-8.4,5.755,7.887,7.887,0,0,0,1.014,1.338c.348.094,7.782-5.436,7.827-5.934",
    transform: "translate(-321.289 -687.726)",
    fill: "#d6dbdd"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_39048",
    "data-name": "Path 39048",
    d: "M338.134,692.714c1.542-.334,5.338-1.115,7.427-1.469a8.215,8.215,0,0,1,1.41-.178c.462.116,1.86,9.854,1.86,9.854s-.555.132-1.422.334c-2.348.545-6.976,1.587-9.018,1.832a2.558,2.558,0,0,1-.972.017s-.405-10.109.06-10.244c.067-.019.3-.071.656-.148",
    transform: "translate(-122.823 -251.673)",
    fill: "#1d1c1c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39049",
    "data-name": "Path 39049",
    d: "M353.6,685.181a3.111,3.111,0,0,1,.381-1.288,56.6,56.6,0,0,1,5.619-8.766c.516-.645.877-1.016.964-.941,1.993,1.747,7.1,5.949,8.273,6.63.234.134.1.6-.262,1.263a55.394,55.394,0,0,1-6.156,7.805,5.437,5.437,0,0,1-.871.846c-.408.126-7.875-4.963-7.948-5.549",
    transform: "translate(-128.774 -245.523)",
    fill: "#1d1c1c"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_13023",
    "data-name": "Group 13023",
    transform: "translate(230.823 428.653)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13022",
    "data-name": "Group 13022"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13021",
    "data-name": "Group 13021",
    clipPath: "url(#clip-path-40)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39050",
    "data-name": "Path 39050",
    d: "M372.011,682.078c-2.058-.8-6.936-4.985-8.975-6.951.515-.646.877-1.015.964-.94,1.993,1.745,7.1,5.948,8.272,6.629.234.134.1.6-.261,1.263",
    transform: "translate(-363.036 -674.176)",
    fill: "#d6dbdd"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_13026",
    "data-name": "Group 13026",
    transform: "translate(224.819 438.369)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13025",
    "data-name": "Group 13025"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13024",
    "data-name": "Group 13024",
    clipPath: "url(#clip-path-41)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39051",
    "data-name": "Path 39051",
    d: "M353.6,690.746a3.11,3.11,0,0,1,.381-1.288c2.133,2.691,6.246,4.928,8.438,5.991a5.43,5.43,0,0,1-.871.846c-.408.126-7.875-4.963-7.948-5.549",
    transform: "translate(-353.593 -689.457)",
    fill: "#d6dbdd"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_13029",
    "data-name": "Group 13029",
    transform: "translate(214.431 441.041)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13028",
    "data-name": "Group 13028"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13027",
    "data-name": "Group 13027",
    clipPath: "url(#clip-path-42)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39052",
    "data-name": "Path 39052",
    d: "M338.134,693.66a23.659,23.659,0,0,1,.256,10.374,2.559,2.559,0,0,1-.972.017s-.405-10.109.06-10.244c.067-.019.3-.071.656-.148",
    transform: "translate(-337.254 -693.66)",
    fill: "#d6dbdd"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_13032",
    "data-name": "Group 13032",
    transform: "translate(222.738 439.39)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13031",
    "data-name": "Group 13031"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13030",
    "data-name": "Group 13030",
    clipPath: "url(#clip-path-43)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39053",
    "data-name": "Path 39053",
    d: "M350.319,691.246a8.221,8.221,0,0,1,1.409-.178c.462.116,1.86,9.854,1.86,9.854s-.555.132-1.423.334a54.862,54.862,0,0,0-1.846-10.01",
    transform: "translate(-350.319 -691.063)",
    fill: "#d6dbdd"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_39054",
    "data-name": "Path 39054",
    d: "M354.9,680.928s-3.468,13.121-10.708,15.693c-5.8,2.06-11.2,3.971-11.86,4.176a8.352,8.352,0,0,1-2.536-.167c-4.192-.652-11.2-8.6-11.092-9.477.141-1.134,2.616-5.446,5.493-4.109,2.274,1.057,2.972,4.619,5.254,4.994a4.946,4.946,0,0,0,1.263.112c.426-.077,5.211-1.7,10.546-3.528,7.128-2.445,6.432-11.934,6.432-11.934Z",
    transform: "translate(-116.066 -246.438)",
    fill: "#009edd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39055",
    "data-name": "Path 39055",
    d: "M353.69,682.744c-1.955,3.342-4.307,11.934-9.052,13.619-5.759,2.045-10.857,3.847-11.723,4.131a12.156,12.156,0,0,1-2.185-.223c-3.346-.549-8.27-6.362-9.366-7.98a5.7,5.7,0,0,1,2.108-2.5,1.059,1.059,0,0,1,1.021-.052c1.546.719,3.023,3.513,4.067,4.1a6.855,6.855,0,0,0,1.828,1.038,4.752,4.752,0,0,0,1.577.086c.493-.089,5.205-1.681,10.633-3.541,4.907-1.682,4.721-8.142,6.617-11.313Z",
    transform: "translate(-117.036 -247.685)",
    fill: "#29bef3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39056",
    "data-name": "Path 39056",
    d: "M325.468,692.218a2.375,2.375,0,0,0-.581-1.1,44.011,44.011,0,0,0-5.851-5.516c-3.7-2.135-9.027,1.908-7.421,5.144a84.812,84.812,0,0,0,5.625,7.09,7.9,7.9,0,0,0,1.167,1.207c.357.052,7.077-6.328,7.061-6.827",
    transform: "translate(-113.379 -249.468)",
    fill: "#1d1c1c"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_13035",
    "data-name": "Group 13035",
    transform: "translate(203.861 441.653)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13034",
    "data-name": "Group 13034"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13033",
    "data-name": "Group 13033",
    clipPath: "url(#clip-path-44)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39057",
    "data-name": "Path 39057",
    d: "M328.858,695.719a2.375,2.375,0,0,0-.581-1.1,27.683,27.683,0,0,1-7.647,6.717,7.893,7.893,0,0,0,1.167,1.207c.357.052,7.077-6.328,7.061-6.827",
    transform: "translate(-320.63 -694.622)",
    fill: "#d6dbdd"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_39058",
    "data-name": "Path 39058",
    d: "M337.074,698.476c1.491-.516,5.167-1.745,7.2-2.346a8.193,8.193,0,0,1,1.378-.345c.473.06,3.025,9.561,3.025,9.561s-.535.2-1.373.5c-2.265.822-6.736,2.41-8.734,2.9a2.585,2.585,0,0,1-.963.133s-1.611-9.989-1.165-10.177c.064-.026.29-.107.634-.225",
    transform: "translate(-122.498 -253.393)",
    fill: "#1d1c1c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39059",
    "data-name": "Path 39059",
    d: "M352.065,689.336a3.14,3.14,0,0,1,.224-1.325,56.632,56.632,0,0,1,4.531-9.375c.435-.7.75-1.113.845-1.049,2.187,1.5,7.762,5.057,9.005,5.593.249.1.175.58-.108,1.284a55.339,55.339,0,0,1-5.18,8.486,5.513,5.513,0,0,1-.762.944c-.39.174-8.412-3.986-8.555-4.558",
    transform: "translate(-128.211 -246.763)",
    fill: "#1d1c1c"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_13038",
    "data-name": "Group 13038",
    transform: "translate(228.609 430.818)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13037",
    "data-name": "Group 13037"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13036",
    "data-name": "Group 13036",
    clipPath: "url(#clip-path-45)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39060",
    "data-name": "Path 39060",
    d: "M369.3,684.465c-2.138-.545-7.482-4.121-9.741-5.828.434-.7.749-1.113.844-1.049,2.187,1.5,7.762,5.057,9.005,5.593.249.1.175.58-.108,1.285",
    transform: "translate(-359.554 -677.581)",
    fill: "#d6dbdd"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_13041",
    "data-name": "Group 13041",
    transform: "translate(223.836 441.248)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13040",
    "data-name": "Group 13040"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13039",
    "data-name": "Group 13039",
    clipPath: "url(#clip-path-46)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39061",
    "data-name": "Path 39061",
    d: "M352.065,695.311a3.14,3.14,0,0,1,.224-1.325c2.44,2.417,6.791,4.146,9.093,4.939a5.513,5.513,0,0,1-.762.944c-.39.174-8.412-3.986-8.555-4.558",
    transform: "translate(-352.047 -693.985)",
    fill: "#d6dbdd"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_13044",
    "data-name": "Group 13044",
    transform: "translate(213.864 445.084)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13043",
    "data-name": "Group 13043"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13042",
    "data-name": "Group 13042",
    clipPath: "url(#clip-path-47)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39062",
    "data-name": "Path 39062",
    d: "M337.074,700.018a23.656,23.656,0,0,1,1.494,10.269,2.585,2.585,0,0,1-.963.134s-1.611-9.989-1.165-10.177c.064-.026.29-.107.634-.225",
    transform: "translate(-336.362 -700.019)",
    fill: "#d6dbdd"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_13047",
    "data-name": "Group 13047",
    transform: "translate(221.774 442.392)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13046",
    "data-name": "Group 13046"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13045",
    "data-name": "Group 13045",
    clipPath: "url(#clip-path-48)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39063",
    "data-name": "Path 39063",
    d: "M348.8,696.131a8.177,8.177,0,0,1,1.378-.345c.472.06,3.025,9.561,3.025,9.561s-.536.2-1.373.5a54.914,54.914,0,0,0-3.03-9.717",
    transform: "translate(-348.803 -695.784)",
    fill: "#d6dbdd"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_39064",
    "data-name": "Path 39064",
    d: "M360.961,682.042s.018,13.571-6.319,17.916c-5.076,3.48-9.808,6.716-10.391,7.082a8.355,8.355,0,0,1-2.494.49c-4.219.447-13.034-5.438-13.154-6.31-.155-1.133,1.129-5.936,4.254-5.382,2.469.438,4.058,3.7,6.361,3.478a4.959,4.959,0,0,0,1.249-.216c.392-.184,4.6-2.979,9.285-6.118,6.261-4.193,3.151-13.186,3.151-13.186Z",
    transform: "translate(-119.668 -247.57)",
    fill: "#4b7b2e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39065",
    "data-name": "Path 39065",
    d: "M359.928,684.273c-1.031,3.732-1.1,12.64-5.251,15.487-5.041,3.456-9.5,6.507-10.269,7a12.191,12.191,0,0,1-2.17.346c-3.374.329-9.626-4.025-11.1-5.307a5.7,5.7,0,0,1,1.395-2.959,1.06,1.06,0,0,1,.973-.312c1.679.3,3.824,2.619,4.985,2.922a6.846,6.846,0,0,0,2.033.534,4.776,4.776,0,0,0,1.548-.321c.454-.213,4.6-2.962,9.367-6.154,4.311-2.886,2.471-9.082,3.489-12.633Z",
    transform: "translate(-120.596 -248.692)",
    fill: "#29bef3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39066",
    "data-name": "Path 39066",
    d: "M333.9,703.884a2.377,2.377,0,0,0-.843-.911,44.014,44.014,0,0,0-7.072-3.829c-4.126-1.113-8.234,4.163-5.851,6.877a84.8,84.8,0,0,0,7.257,5.408,7.9,7.9,0,0,0,1.438.867c.359-.042,5.214-7.932,5.071-8.412",
    transform: "translate(-116.332 -254.561)",
    fill: "#1d1c1c"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_13050",
    "data-name": "Group 13050",
    transform: "translate(211.058 448.412)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13049",
    "data-name": "Group 13049"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13048",
    "data-name": "Group 13048",
    clipPath: "url(#clip-path-49)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39067",
    "data-name": "Path 39067",
    d: "M338.459,706.164a2.377,2.377,0,0,0-.843-.911,27.692,27.692,0,0,1-5.666,8.456,7.884,7.884,0,0,0,1.438.867c.359-.042,5.214-7.932,5.071-8.412",
    transform: "translate(-331.95 -705.253)",
    fill: "#d6dbdd"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_39068",
    "data-name": "Path 39068",
    d: "M346.577,706.478c1.308-.882,4.545-3.014,6.354-4.116a8.185,8.185,0,0,1,1.243-.687c.472-.064,5.379,8.463,5.379,8.463s-.467.328-1.2.837c-1.979,1.377-5.891,4.059-7.7,5.044a2.564,2.564,0,0,1-.9.376s-4.122-9.24-3.74-9.537c.055-.042.253-.177.555-.38",
    transform: "translate(-126.007 -255.537)",
    fill: "#1d1c1c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39069",
    "data-name": "Path 39069",
    d: "M359.922,694.336A3.139,3.139,0,0,1,359.8,693a56.536,56.536,0,0,1,1.972-10.224c.239-.791.438-1.268.547-1.231,2.5.883,8.8,2.894,10.139,3.093.267.037.318.516.225,1.27a55.352,55.352,0,0,1-2.826,9.531,5.548,5.548,0,0,1-.495,1.108c-.333.268-9.154-1.692-9.439-2.208",
    transform: "translate(-131.03 -248.205)",
    fill: "#1d1c1c"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_13053",
    "data-name": "Group 13053",
    transform: "translate(230.74 433.336)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13052",
    "data-name": "Group 13052"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13051",
    "data-name": "Group 13051",
    clipPath: "url(#clip-path-50)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39070",
    "data-name": "Path 39070",
    d: "M373.816,685.905c-2.207.023-8.29-2.061-10.911-3.131.239-.79.438-1.268.547-1.231,2.5.884,8.8,2.894,10.139,3.093.267.037.318.516.225,1.27",
    transform: "translate(-362.905 -681.541)",
    fill: "#d6dbdd"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_13056",
    "data-name": "Group 13056",
    transform: "translate(228.759 444.793)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13055",
    "data-name": "Group 13055"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13054",
    "data-name": "Group 13054",
    clipPath: "url(#clip-path-51)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39071",
    "data-name": "Path 39071",
    d: "M359.922,700.9a3.139,3.139,0,0,1-.124-1.338c2.979,1.71,7.628,2.263,10.057,2.438a5.545,5.545,0,0,1-.495,1.108c-.333.268-9.154-1.692-9.439-2.208",
    transform: "translate(-359.789 -699.56)",
    fill: "#d6dbdd"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_13059",
    "data-name": "Group 13059",
    transform: "translate(226.924 446.137)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13058",
    "data-name": "Group 13058"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13057",
    "data-name": "Group 13057",
    clipPath: "url(#clip-path-52)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39072",
    "data-name": "Path 39072",
    d: "M356.9,702.362a8.221,8.221,0,0,1,1.243-.688c.472-.063,5.379,8.463,5.379,8.463s-.467.329-1.2.837a54.879,54.879,0,0,0-5.424-8.613",
    transform: "translate(-356.903 -701.674)",
    fill: "#d6dbdd"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_39073",
    "data-name": "Path 39073",
    d: "M341.017,664.98l-4.06,2.687a9.833,9.833,0,0,1-10.276.355l-22.889-12.974a9.832,9.832,0,0,1-4.984-8.674l.113-9.223Z",
    transform: "translate(-108.822 -232.039)",
    fill: "#1d1c1c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39074",
    "data-name": "Path 39074",
    d: "M305.7,619.659s35.789,21.78,38.736,24.531,4.348,18.29,3.164,20.146-54.007-29.844-53.453-31.669,8.557-13.442,11.553-13.009",
    transform: "translate(-107.122 -225.664)",
    fill: "#d6dbdd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_13062",
    "data-name": "Group 13062",
    transform: "translate(166.945 361.182)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13061",
    "data-name": "Group 13061"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13060",
    "data-name": "Group 13060",
    clipPath: "url(#clip-path-53)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39075",
    "data-name": "Path 39075",
    d: "M310.079,606.366s-1.788,8.833-23.878,8.45c-21.431-.372-23.632-9.274-23.632-9.274a123.694,123.694,0,0,1,7.361-37.484s-1.613,16.8,3.707,29.559,36.442,8.749,36.442,8.749",
    transform: "translate(-262.569 -568.059)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_39076",
    "data-name": "Path 39076",
    d: "M305.335,473.082c-6.643,4.95-15.675,4.628-20.172-.72s-2.758-13.7,3.885-18.646,15.675-4.628,20.172.72,2.758,13.7-3.885,18.647",
    transform: "translate(-102.942 -163.955)",
    fill: "#686868"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39077",
    "data-name": "Path 39077",
    d: "M364.206,411.11c-2.17.526-5.207.133-9.556-3.046-7.131-5.231-7.44-12.406-6.731-16.9a21.858,21.858,0,0,1,3.292-.862c.377-.071.746-.122,1.106-.166a18.112,18.112,0,0,1,7.886.588c5.361,4.985,7.292,8.488,6.864,12.515a14.771,14.771,0,0,1-.924,3.65,36.782,36.782,0,0,1-1.938,4.224",
    transform: "translate(-126.613 -142.018)",
    fill: "#d6dbdd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_13065",
    "data-name": "Group 13065",
    transform: "translate(221.048 248.116)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13064",
    "data-name": "Group 13064"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13063",
    "data-name": "Group 13063",
    clipPath: "url(#clip-path-54)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39078",
    "data-name": "Path 39078",
    d: "M364.206,411.206c-2.17.526-5.207.133-9.556-3.046-7.131-5.231-7.44-12.406-6.731-16.9a21.854,21.854,0,0,1,3.292-.862c.377-.071.746-.122,1.106-.166a19.27,19.27,0,0,1,8.755,5.566,18.618,18.618,0,0,1,5.072,11.187,36.784,36.784,0,0,1-1.938,4.224",
    transform: "translate(-347.661 -390.229)",
    fill: "#121212"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_39079",
    "data-name": "Path 39079",
    d: "M364.306,374.128l-27.084,32.43,4.325,3.932,27.7-33.933Z",
    transform: "translate(-122.811 -136.25)",
    fill: "#1d1c1c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39080",
    "data-name": "Path 39080",
    d: "M375.3,379.469l-26.853,34.782,4.533,3.69L380.2,381.873Z",
    transform: "translate(-126.9 -138.195)",
    fill: "#4e4e4e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39081",
    "data-name": "Path 39081",
    d: "M351.079,414.717c-6.082,10.874-18.673,16.291-18.673,16.291L314.781,413.3s3.793-11.95,14.086-19.221a25.169,25.169,0,0,1,8.878-4.066l.012,0a.917.917,0,0,1,1.124.9c-.005,3.8.785,10.331,5.717,14.254,5.527,4.392,8.328,2.3,10.252-.406a.325.325,0,0,1,.585.252c-.067.3-.147.607-.24.914l0,.01a45.552,45.552,0,0,1-4.112,8.784",
    transform: "translate(-114.639 -142.023)",
    fill: "#d6dbdd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_13068",
    "data-name": "Group 13068",
    transform: "translate(222.952 247.957)",
    opacity: 0.36
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13067",
    "data-name": "Group 13067"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13066",
    "data-name": "Group 13066",
    clipPath: "url(#clip-path-55)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39082",
    "data-name": "Path 39082",
    d: "M368.26,405.923l0,.01c-1.367,1.975-4.954,5.432-11.321.275-6.777-5.5-6.488-13.377-6.125-16.2l.012,0a.917.917,0,0,1,1.124.9c-.005,3.8.785,10.331,5.717,14.254,5.526,4.392,8.327,2.3,10.252-.405a.325.325,0,0,1,.585.252c-.067.3-.148.607-.24.914",
    transform: "translate(-350.656 -389.979)",
    fill: "#1d1c1c"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_39083",
    "data-name": "Path 39083",
    d: "M319.668,438.035l-21.4,27.765a2.046,2.046,0,0,0,2.9,2.844l25.071-20.136Z",
    transform: "translate(-108.468 -159.524)",
    fill: "#d6dbdd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39084",
    "data-name": "Path 39084",
    d: "M305.779,482.5a2.449,2.449,0,1,1-1.281-3.218,2.448,2.448,0,0,1,1.281,3.218",
    transform: "translate(-109.649 -174.473)",
    fill: "#1d1c1c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39085",
    "data-name": "Path 39085",
    d: "M306.617,482.92a2.271,2.271,0,1,1-1.188-2.984,2.271,2.271,0,0,1,1.188,2.984",
    transform: "translate(-110.078 -174.716)",
    fill: "#4b7b2e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39086",
    "data-name": "Path 39086",
    d: "M307.1,483.275a1.827,1.827,0,1,1-.956-2.4,1.827,1.827,0,0,1,.956,2.4",
    transform: "translate(-110.567 -175.071)",
    fill: "#559c33"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39087",
    "data-name": "Path 39087",
    d: "M389.127,371.251a8.586,8.586,0,1,1-11.64-3.456,8.586,8.586,0,0,1,11.64,3.456",
    transform: "translate(-135.838 -133.565)",
    fill: "#121212"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39088",
    "data-name": "Path 39088",
    d: "M381.871,378.867a3.227,3.227,0,1,0,2.5-3.817,3.227,3.227,0,0,0-2.5,3.817",
    transform: "translate(-139.047 -136.56)",
    fill: "#1d1c1c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39089",
    "data-name": "Path 39089",
    d: "M380.973,379.217a2.993,2.993,0,1,0,2.319-3.541,2.993,2.993,0,0,0-2.319,3.541",
    transform: "translate(-138.722 -136.79)",
    fill: "#009edd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39090",
    "data-name": "Path 39090",
    d: "M380.98,379.62a2.407,2.407,0,1,0,1.865-2.848,2.408,2.408,0,0,0-1.865,2.848",
    transform: "translate(-138.729 -137.194)",
    fill: "#29bef3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39091",
    "data-name": "Path 39091",
    d: "M632.99,133l-73.629,7.228s-7.4,6.259-7.229,19.528c.166,12.581,7.47,18.072,7.47,18.072l73.715,6.283Z",
    transform: "translate(-201.078 -48.435)",
    fill: "#652e13"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39092",
    "data-name": "Path 39092",
    d: "M663.553,125.817l-86.338,8.475s-8.682,7.339-8.476,22.9c.195,14.753,8.759,21.192,8.759,21.192l86.44,7.368Z",
    transform: "translate(-207.125 -45.818)",
    fill: "#a9471b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39093",
    "data-name": "Path 39093",
    d: "M727.692,155.641c-.106-16.55-10.175-29.9-22.489-29.824s-22.211,13.56-22.1,30.11,10.175,29.9,22.489,29.823,22.211-13.559,22.1-30.11",
    transform: "translate(-248.774 -45.818)",
    fill: "#cd5719"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39094",
    "data-name": "Path 39094",
    d: "M726.4,157.988c-.092-14.305-8.795-25.846-19.439-25.778s-19.2,11.72-19.107,26.026,8.8,25.846,19.439,25.778,19.2-11.721,19.107-26.026",
    transform: "translate(-250.506 -48.146)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39095",
    "data-name": "Path 39095",
    d: "M713.376,184.9a15.381,15.381,0,0,1-8.817-2.8,14.942,14.942,0,0,0,6.686,1.554c10.643-.069,19.2-11.721,19.106-26.026-.064-10.045-4.374-18.726-10.621-22.983,7.377,3.6,12.681,13.074,12.753,24.225.092,14.305-8.463,25.958-19.107,26.026",
    transform: "translate(-256.591 -49.037)",
    fill: "#a9471b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39096",
    "data-name": "Path 39096",
    d: "M568.385,144.6l-73.629,7.228s-7.4,6.259-7.229,19.528c.166,12.581,7.47,18.072,7.47,18.072l73.715,6.283Z",
    transform: "translate(-177.55 -52.66)",
    fill: "#7a3616"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39097",
    "data-name": "Path 39097",
    d: "M598.948,137.418l-86.338,8.475s-8.682,7.339-8.477,22.9c.2,14.753,8.76,21.192,8.76,21.192l86.44,7.368Z",
    transform: "translate(-183.597 -50.043)",
    fill: "#c14e1a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39098",
    "data-name": "Path 39098",
    d: "M663.087,167.242c-.106-16.55-10.175-29.9-22.489-29.824s-22.211,13.56-22.1,30.11,10.175,29.9,22.489,29.824,22.211-13.559,22.1-30.11",
    transform: "translate(-225.246 -50.043)",
    fill: "#e5601a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39099",
    "data-name": "Path 39099",
    d: "M661.794,169.589c-.092-14.305-8.795-25.846-19.439-25.778s-19.2,11.72-19.107,26.026,8.8,25.846,19.439,25.778,19.2-11.721,19.107-26.026",
    transform: "translate(-226.978 -52.371)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39100",
    "data-name": "Path 39100",
    d: "M648.771,196.505a15.382,15.382,0,0,1-8.818-2.8,14.943,14.943,0,0,0,6.686,1.554c10.644-.068,19.2-11.721,19.106-26.026-.064-10.045-4.374-18.726-10.621-22.983,7.377,3.6,12.681,13.074,12.753,24.225.092,14.305-8.463,25.958-19.107,26.026",
    transform: "translate(-233.062 -53.261)",
    fill: "#c14e1a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39101",
    "data-name": "Path 39101",
    d: "M252.837,824.015h0a6.836,6.836,0,0,1-6.909-8.271l77.3-469.66a10.144,10.144,0,0,1,9.633-8.271,6.836,6.836,0,0,1,6.909,8.271l-77.3,469.66a10.144,10.144,0,0,1-9.633,8.271",
    transform: "translate(-89.522 -123.025)",
    fill: "#7f3b17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39102",
    "data-name": "Path 39102",
    d: "M414.72,824.015h0a6.836,6.836,0,0,1-6.909-8.271l77.3-469.66a10.144,10.144,0,0,1,9.633-8.271,6.836,6.836,0,0,1,6.909,8.271l-77.3,469.66a10.144,10.144,0,0,1-9.633,8.271",
    transform: "translate(-148.478 -123.025)",
    fill: "#7f3b17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39103",
    "data-name": "Path 39103",
    d: "M473.857,407.211H356.685l2.8-17H476.655Z",
    transform: "translate(-129.9 -142.106)",
    fill: "#7f3b17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39104",
    "data-name": "Path 39104",
    d: "M449.116,557.531H331.944l2.8-17H451.914Z",
    transform: "translate(-120.889 -196.851)",
    fill: "#7f3b17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39105",
    "data-name": "Path 39105",
    d: "M424.375,707.852H307.2l2.8-17H427.173Z",
    transform: "translate(-111.879 -251.595)",
    fill: "#7f3b17"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorRobot404);
export default __webpack_public_path__ + "static/media/Error_Robot_404.500bac4396555a25427b12dc3c7d71a0.svg";
export { ForwardRef as ReactComponent };